<template>
<div v-if="!cloudLoading" id="file-container" :class="{
      'file-container': true,
      'file-container-other': !(isWps || isVideo),
      'file-container-doc-mobile': isDocMobile,
    }">
    <v-touch v-show="!showHistory" v-on:swipeleft="next" v-on:swiperight="pre" class="touch-container">
      <div class="touch-container" v-loading="loading" :element-loading-text="$t('文件加载中#!!!#src/pages/H5/Cloud/views/File.vue_1')" customClass="loading-box" element-loading-background="rgba(255, 255, 255, 0.8)">
        <sensitiveBlockedHeader v-if="isShowSensitiveBlocked">
            <template #avatar="">
                <avatar v-if="isCloud && !isOuterFile" :tocaShowLoginOut="!is_inTocaApp" @handleLogOutShow="logOutVisible = true" :isCurrent="true" :isMettingDoc="isMettingDoc" :user-info="currentUserParams"></avatar>
            </template>
        </sensitiveBlockedHeader>
        <div v-show="isPcMode && !this.hideHeader && !isEditorPreview && !isShowSensitiveBlocked" :class="{
            header: true,
            'wps-custom-header': isWps,
            'wps-shadow': true
          }">
          <div v-if="isKBDirExpandShow && isWiki">
            <moo-tooltip effect="light" :content="$t('展开#!!!#src/pages/H5/Cloud/views/File.vue_1')" placement="bottom" :popper-class="tooltipClass" :visible-arrow="false">
              <div class="expandBtnContainer" @click="expandDir">
                <svg-icon class="kb_dir_expand_icon" icon-class="dir_expand"></svg-icon>
              </div>
            </moo-tooltip>
          </div>
          <moo-popover v-if="!isSafe" popper-class="recent-file-popper" placement="right-end" width="467" trigger="hover" :close-delay="0" :visible-arrow="false" v-model="recentVisible">
                <HoverContainerView v-if="this.isLogin" :currentFileId="fileId"></HoverContainerView>
                <div @click="goToHomePage" v-if="isLogin && !isWiki && !isMettingDoc && !is_inTocaApp" slot="reference" class="recent-file-btn">
                    <svg-icon icon-class="icon-file-recent" class-name="icon-file-recent"></svg-icon>
                </div>
          </moo-popover>
          <div class="recent-file-right-line"></div>
          <div v-if="isHasAuth(this.auth)" :class="{
              'header-left': true,
              'header-left-center': !routeItems.length || isHome || isSafe,
            }">
            <div :class="[
                'header-left-top',
                isShowBreadCrumb === false ? 'header-left-top-nobread' : '',
              ]">
              <div v-if="editTitlePermission" class="input-box">
                <label v-html="fileTitle" id="label" class="input-box__label"></label>
                <input maxLength="100" @input="handleTitleChange" :value="fileTitle" type="text" ref="titleInput" id="input" class="input-box__input" :autofocus="true" @keyup.enter="handleInputBlur" @blur="handleSaveTitle">
              </div>
              <div @click="handleEditTitle" v-else class="title">
                {{ this.metadata?.fileName }}
              </div>
              <div v-if="isTemplate" :class="[
                  'templateMark',
                  cloudI18n === 'en-us' ? 'templateMark_en' : '',
                ]">
                <svg-icon :icon-class="
                    cloudI18n === 'en-us' ? 'template_mark_en' : 'template_mark'
                  "></svg-icon>
              </div>
              <FileStar :metadata="metadata" :isCloudDiskDoc="isCloudDiskDoc"></FileStar>
              <Read :isLogin="isLogin" @applyAuth="changeToApplyAuthView" :auth="auth" v-show="showRead && !isOuterFile"></Read>
              <div v-if="isShowCheckReminder" id="check_reminder_container" @click="hideAuthAndShare(true)"></div>
            </div>
            <div v-if="isShowBreadCrumb" class="header-crumb">
              <div class="bread-crumb-icon">
                <img src="@/assets/h5/dir_brand.png" class="icon">
              </div>
              <MettingBreadCrumb v-if="isMettingDoc"></MettingBreadCrumb>
              <BreadCrumb v-if="!isMettingDoc" :metadata="metadata" :isWiki="isWiki" :spaceId="spaceId" :userId="userId" :routeItems="routeItems" separator="/"></BreadCrumb>
            </div>
          </div>
          <div v-else class="header-left header-left-noAuth">
            <div class="title">{{$t("没有访问权限#!!!#src/pages/H5/Cloud/views/File.vue_1")}}</div>
          </div>
          <div v-if="showHeaderMiddle" class="header-middle">
            <span :class="{ 'excel-bar': item.command == currentExcelBar }" @click="handleWpsTab(item)" v-for="item in headerMiddleOptions" :key="item?.command">
              {{ item.name }}</span>
          </div>
          <div v-if="isLogin" class="header-right">
            <div v-if="(this.isWps || isEditor) && !isHome">
              <div v-if="this.editUser.length > 1" class="edit-user">
                <edit-avatar :user-info="editor" v-for="editor in showEditUserList" :key="editor?.id"></edit-avatar>
                <moo-popover popper-class="edit-popper" placement="top" width="160" trigger="click" v-model="editVisible" :close-delay="0">
                  <div class="edit-pop">
                    <select-avatar :user-info="editor" v-for="editor in hiddenEditUserList" :key="editor.id"></select-avatar>
                  </div>
                    <div slot="reference" class="more_user_count">
                        <div class="number">{{ moreUserCount }}</div>
                    </div>
                </moo-popover>
              </div>
              <div :class="['edit-user','edit-user-no-more-user']" v-else>
                <edit-avatar :user-info="editor" :key="editor?.id" v-for="editor in showEditUserList"></edit-avatar>
              </div>
            </div>
            <div v-if="!isMettingDoc" style="display: none;" class="link_share_range_set" id="link_share_range_set"></div>
            <!-- 发送邮件-->
            <div v-if="isShowSendEmail" class="sendEmail" @click="gotoSendEmail">{{$t("发送邮件#!!!#src/pages/H5/Cloud/views/File.vue_1")}}            </div>

            <FileShareView ref="fileShareViewRef" v-if="!noAuthHideShare && !isSafe" :isWiki="isWiki" :myAuth="auth" :showShare="showAuthManage" :fileId="fileId" :fileUrl="metadata?.fileUrl" :isFileOwner="isFileOwner" :userInfo="currentUserParams" :sameSpace="sameSpace" :isMettingDoc="isMettingDoc" :contentType="contentType" @closeShareView="handleCloseShareView" @applyAuth="changeToApplyAuthView" @updateAuthInfos="updateAuthInfos" @updateLinkShareRange="updateLinkShareRange" @onLinkRangeSetDropdownVisible="onLinkRangeSetDropdownVisible" @UpdateLinkShareRangeSet="UpdateLinkShareRangeSet">
              <moo-tooltip slot="reference" effect="light" :content="auth === 'ALL' || (auth === 'WRITE' && isFileOwner)
  ? $t('权限管理#!!!#src/pages/H5/Cloud/views/File.vue_1')
  : $t('查看协作者#!!!#src/pages/H5/Cloud/views/File.vue_1')" placement="bottom" popper-class="share-tooltip-class" :visible-arrow="false" :manual="true" :value="showShareTip">
                <div class="authManageBtn" @click.prevent="clickAuthManage" @mouseenter="shareMouseEnter" @mouseleave="showShareTip = false">
                  <svg-icon icon-class="cloud-auth-manage" class="share-btn-auth-manage"></svg-icon>
                </div>
              </moo-tooltip>
            </FileShareView>

            <!--pc端内放开分享按钮 v-if="!(isHome || isSafe)" -->
            <FileShareScopeView ref="fileShareScopeViewRef" :isWiki="isWiki" v-if="!isSafe" :noAuthHideShare="noAuthHideShare" :showShareScope="showAuthShare" :myAuth="auth" :fileId="fileId" :fileUrl="metadata?.fileUrl" :isFileOwner="isFileOwner" @closeShareView="handleCloseShareView" @pushToAuthManageView="pushToAuthManageView" @updateLinkShareRange="updateLinkShareRange" @onLinkRangeSetDropdownVisible="onLinkRangeSetDropdownVisible" @UpdateLinkShareRangeSet="UpdateLinkShareRangeSet">
              <moo-tooltip slot="reference" effect="light" :content="shareAuthTip" placement="bottom" popper-class="share-tooltip-class" :visible-arrow="false" :manual="true" :value="showShareScopeTip">
                <div class="shareBtn" @click.prevent="clickShare" @mouseenter="shareScopeMouseEnter" @mouseleave="showShareScopeTip = false">
                  <svg-icon icon-class="cloud-auth-share" class="share-btn-auth-manage"></svg-icon>
                </div>
              </moo-tooltip>
            </FileShareScopeView>

            <!-- 会议纪要创建副本 -->
            <CreateCopyButton v-if="isHasReadDownloadAuth(this.auth) && !isSafe" ref="createCopyDialog" :userId="userId" :spaceId="spaceId" :owner="owner" :docInfo="{ ...docInfo, ...precheckDocInfo }" :userInfo="currentUser" @clickCreateCopy="clickCreateCopy"></CreateCopyButton>

            <div v-if="showDownload && !isHome && !isOuterFile" class="download-btn" @click="onDownload(fileId, true)">
              <svg-icon v-show="this.contentType !== 'FOLDER'" icon-class="icon-file-download" class="download-btn-icon"></svg-icon>
              {{ downloadTitle }}
            </div>
            <div v-if="showEdiTorMode" :class="[
                'edit-btn',
                isSupportEdit === false ? 'edit-btn-disabled' : '',
              ]" @click="onEditorModeChange(fileId)">
              <svg-icon :icon-class="editorIconClass" class="edit-btn-icon"></svg-icon>
              {{ editorModeText }}
            </div>
            <div class="line" v-if="showAdd && !isSafe"></div>
            <CreatePopper :metadata="metadata" v-if="
                showAdd && !(is_inTocaApp || isHome || isSafe || isMettingDoc)
              " @handleCreate="handleCreate" @handleUpload="handleUpload"></CreatePopper>
            <MorePopper v-if="!isSafe" :isHome="isHome" :exportOptions="exportOptions" ref="headerMore" :fileId="fileId" :is_inTocaApp="is_inTocaApp" @handleExport="handleExport" @handleMore="handleMore" @templateSwitchChange="templateSwitchChange" @onPopperShow="onMorePopperShow" :isTemplate="isTemplate" :auth="auth" :isWps="isWps" :isWiki="isWiki" :isEditor="isEditor" :isOtherFile="isOtherFile" :officeFileType="officeFileType" :isFileOwner="isFileOwner" :isMettingDoc="isMettingDoc" :metadata="metadata" :precheckDocInfo="precheckDocInfo" :currentUser="currentUser" :isHasTemplateAuth="isHasReadDownloadAuth(this.auth)" :contentType="this.contentType" :isSafe="isSafe"></MorePopper>
            <!-- <OpenPopper :isHome="isHome" v-if="isHome"></OpenPopper> -->
            <FeedbackBtn v-if="!isHome && isLogin && !isSafe"></FeedbackBtn>
            <div v-if="isCloud && isLogin && !isSafe" class="line"></div>
            <avatar v-if="isCloud && !isOuterFile" :tocaShowLoginOut="!is_inTocaApp" @handleLogOutShow="logOutVisible = true" :isCurrent="true" :isMettingDoc="isMettingDoc" :user-info="currentUserParams"></avatar>
          </div>
          <div v-else class="header-right">
            <div v-if="showDownload" class="download-btn btn-margin" @click="onDownload(fileId, true)">
              <svg-icon v-show="this.contentType !== 'FOLDER'" icon-class="icon-file-download" class="download-btn-icon"></svg-icon>
              {{ downloadTitle }}
            </div>
            <FeedbackBtn v-if="isLogin && !isSafe"></FeedbackBtn>
            <div class="line" v-if="!isSafe"></div>
            <div v-if="!isOuterFile" @click="handleLogin" class="login-button">{{$t("登录#!!!#src/pages/H5/Cloud/views/File.vue_1")}}            </div>
          </div>
        </div>
        <div id="sensitive_content_tip" v-if="showSensitiveContentTips"></div>
        <div v-show="isShowTemplateInfo" class="templateInfo" id="templateInfo">
          <TemplateInfoHead :creatorName="templateInfo?.templateCreator?.userName" :useTimes="templateInfo?.useTimes" :templateId="templateInfo?.id" :locale="cloudI18n" :isWiki="isWiki" @gotoUseTemplate="gotoUseTemplate"></TemplateInfoHead>
        </div>
        <div :class="{ 'mobile-header': true, 'wps-custom-mobile-header': isWps }" v-if="!is_inTocaApp && !isPcMode && !this.hideHeader">
          <div class="mobile-header-left">
            <img src="@/assets/h5/file/toca-logo.webp" alt="">
          </div>
          <div v-if="isCanEdit === false" class="mobile-header-right">
            <div v-if="!isLogin && !isOuterFile" @click="handleLogin" class="mobile-login-button">{{$t("登录#!!!#src/pages/H5/Cloud/views/File.vue_2")}}            </div>
            <img v-else @click="handleMobileSignOut" v-show="currentUser?.memberAvatar" :src="currentUser?.memberAvatar" class="mobile-user-avatar">
            <div class="line"></div>
            <MobileHeader @handleViewVisible="handleViewVisible" v-if="!is_inTocaApp" :isEditor="isEditor" :fileId="fileId" :isWiki="isWiki" :docInfo="{ ...docInfo, ...precheckDocInfo }" @download="onDownload" :auth="auth" :folderFileCount="folderFileCount"></MobileHeader>
          </div>
          <div v-else class="mobile-header-right">
            <div class="save" @click="saveKbDoc">
              <DocSaveIcon></DocSaveIcon>
            </div>
          </div>
        </div>
        <div id="water-mark-show" :class="[
            !is_inTocaApp && !isPcMode && !this.hideHeader
              ? 'water-mark-show-mobile'
              : '',
          ]">
          <div id="sensitive_blocked_id" style="flex:1;" v-if="isShowSensitiveBlocked"></div>
          <component v-else :is_inTocaApp="is_inTocaApp" :isMettingDoc="isMettingDoc" :spaceId="spaceId" :sameSpace="sameSpace" :isPreview="isEditorPreview" :belongingFileId="belongingFileId" @handleUpload="handleUpload" @handleCreate="handleCreate" @handleLogin="handleLogin" :editorMode="editorMode" :isLogin="isLogin" ref="componentRef" :auth="auth" :owner="owner" :root-id="rootId" :file-id="fileId" :message="message" :metadata="metadata" :is-public="isPublic" v-bind:is="component" :memberUniqueId="memberUniqueId" :userInfo="currentUser" :readOnly="readOnly" :productType="metadata?.productType" :contentType="contentType" :size="size" @download="onDownload" @downloadPDF="handleExportPDF" @open-item="openItem" @handleGoDownload="handleGoDownload" @handleFileStatus="handleFileStatus" @handleInitExportOptions="handleInitExportOptions" @password-commit="passwordCommit" @loadSuccess="loadSuccess" @imgPreviewDestory="imgPreviewDestory" @handleChangeWikiTitle="handleChangeWikiTitle" @floderAuthChange="floderAuthChange" @onSelectionUpdate="onSelectionUpdate" @onChangeEditStatus="onChangeEditStatus" @updateSource="updateSource"></component>
          <UploadDialog :isFolder="isFolder" :fileUploader="fileUploader" ref="uploadDialog" @open-item="openItem"></UploadDialog>
        </div>
        <moo-dialog :visible.sync="applyAuthDialog" :show-close="false" width="432px" @closed="applyAuthDialog = false">
          <ApplyAuthView :isOpen="applyAuthDialog" :auth="auth" :contentType="contentType" :fileId="fileId" :message="message" :owner="owner" :isDialog="true" @apply-success="applyAuthDialog = false"></ApplyAuthView>
        </moo-dialog>

        <moo-dialog :append-to-body="true" :top="isPcMode ? '15vh' : '35vh'" custom-class="sign-out-dialog" :visible.sync="logOutVisible" :width="isPcMode ? '448px' : '84%'" @closed="logOutVisible = false">
          <div v-if="isPcMode">
            <div class="title">
              <svg-icon class-name="dialog-icon" icon-class="file-warning"></svg-icon>{{$t("退出登录#!!!#src/pages/H5/Cloud/views/File.vue_1")}}            </div>
            <div class="content">{{$t("确定退出登录吗？#!!!#src/pages/H5/Cloud/views/File.vue_1")}}</div>
            <div class="footer">
              <div class="custom-button link-button" @click="logOutVisible = false">{{$t("取 消#!!!#src/pages/H5/Cloud/views/File.vue_1")}}              </div>
              <div class="custom-button primary-button" @click="handleLogOut">{{$t("确 定#!!!#src/pages/H5/Cloud/views/File.vue_1")}}              </div>
            </div>
          </div>
          <div class="mobile-content" v-else>
            <div class="title">{{$t("确认退出吗#!!!#src/pages/H5/Cloud/views/File.vue_1")}}</div>
            <div class="content" :style="{ 'padding-left': '0px' }">{{$t("确定退出登录吗？#!!!#src/pages/H5/Cloud/views/File.vue_2")}}            </div>
            <div class="footer" :style="'justify-content: space-evenly;'">
              <div class="custom-button" @click="logOutVisible = false">{{$t("取 消#!!!#src/pages/H5/Cloud/views/File.vue_2")}}              </div>
              <div class="custom-button primary-button" :style="'margin-left: 0px;'" @click="handleLogOut">{{$t("确 定#!!!#src/pages/H5/Cloud/views/File.vue_2")}}              </div>
            </div>
          </div>
        </moo-dialog>
        <moo-dialog top="20vh" width="543px" :show-close="false" :visible.sync="showTransferDialog" :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true">
          <TransferView :fileId="fileId" :typeInfo="typeInfo" @closeTransferDialog="closeTransferDialog"></TransferView>
        </moo-dialog>
      </div>

      <div class="left-arrow" v-show="currentIndex > 0">
        <img src="@/assets/h5/left-arrow.png" alt="" @click="pre">
      </div>
      <div class="right-arrow" v-show="currentIndex < fileList?.length - 1">
        <img src="@/assets/h5/right-arrow.png" alt="" @click="next">
      </div>

      <moo-drawer :withHeader="false" custom-class="file-drawer" v-if="!isPcMode" :visible.sync="drawerVisible" :direction="'btt'">
        <div class="drawer-title">{{$t("个人信息#!!!#src/pages/H5/Cloud/views/File.vue_1")}}          <svg-icon @click="drawerVisible = false" class-name="drawer-icon" icon-class="file-close"></svg-icon>
        </div>
        <div class="drawer-info">
          <div class="info-item">
            <span>{{$t("头像#!!!#src/pages/H5/Cloud/views/File.vue_1")}}</span>
            <img :src="this.currentUser?.memberAvatar" class="info-avatar">
          </div>
          <div class="info-item">
            <span>{{$t("部门#!!!#src/pages/H5/Cloud/views/File.vue_1")}}</span>
            <div class="info-department">
              {{ departMentInfo }}
            </div>
          </div>
        </div>

        <div @click="logOutVisible = true" class="drawer-sign-out">{{$t("退出登录#!!!#src/pages/H5/Cloud/views/File.vue_2")}}        </div>
        <div class="drawer-title"></div>
      </moo-drawer>
    </v-touch>
    <EditHistory @handleShowHistory="handleShowHistory" :fileId="this.fileId" v-if="showHistory"></EditHistory>
    <div v-if="showSetting" id="preference_setting_dialog"></div>
    <EmailSend v-if="isMettingDoc && !isSendedEmail" ref="emailSend" :loading="isLoading" :fileId="fileId" :fileTitle="fileTitle" @sendEmail="sendEmail" @previewEmail="previewEmail" @closeSend="closeSend"></EmailSend>
    <EmailPreview v-if="isMettingDoc && !isSendedEmail" ref="emailPreview" :loading="isLoading" @sendEmail="sendEmail" @backToSend="backToSend"></EmailPreview>
    <CheckDialog @folderUploadChange="folderUploadChange" @fileUploadChange="fileUploadChange" ref="check"></CheckDialog>
    <moo-dialog :title="$t('确认保存为我的模板？#!!!#src/pages/H5/Cloud/views/File.vue_1')" :visible.sync="saveTemplateDialogVisible" width="529px" custom-class="saveTemplateClass">
      <span>{{$t("保存后，对模板的修改不会影响当前文档，你可以在模板库＞我的模板中查看#!!!#src/pages/H5/Cloud/views/File.vue_1")}}</span>
      <span slot="footer" class="dialog-footer">
        <moo-button @click="saveTemplateDialogVisible = false">{{$t("取消#!!!#src/pages/H5/Cloud/views/File.vue_1")}}</moo-button>
        <moo-button type="primary" @click="clickToSaveTemplate">{{$t("确认#!!!#src/pages/H5/Cloud/views/File.vue_1")}}</moo-button>
      </span>
    </moo-dialog>
    <input v-if="refreshFolderUpload" :style="{ display: 'none' }" ref="folderInput" type="file" @change="handleFolderUpload" webkitdirectory="" multiple="">
    <input v-if="refreshFileUpload" :style="{ display: 'none' }" ref="fileInput" type="file" :accept="
        metadata?.productType === 'CLOUD_DOCUMENT'
          ? '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf'
          : '*/*'
      " @change="handleFileUpload" multiple="">
    <div v-if="showTemplate" id="toca_wiki_template_container" class="toca_wiki_template_container"></div>
    <FileDownloadDialog ref="downloadRef" @downloadFromBrowser="gotoDownloadFromBrowser"></FileDownloadDialog>
    <FolderOperationDialog ref="folderOperationDialog" :sourceFileData="{ ...docInfo, ...precheckDocInfo }" :userInfo="currentUser" :locale="cloudI18n"></FolderOperationDialog>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import cookies from "js-cookie";
import utils from "@/core/h5/utils";
import ImageView from "../components/ImageView";
import MessageView from "../components/Message";
import AudioView from "../components/AudioView";
import DownloadView from "../components/DownloadView";
import OfficeView from "../components/OfficeView";
import TencentOfficeView from "../components/TencentOfficeView";
import PasswordView from "../components/PasswordView";
import VideoView from "../components/VideoView";
import EditorView from "../components/EditView.vue";
import DirectoryView from "../components/DirectoryView";
import FileShareView from "../components/share/FileShareView";
import ApplyAuthView from "../components/ApplyAuthView";
import FileRecentView from "../components/FileRecentView.vue";
import TransferView from "../components/transfer/TransferView.vue";
import FileShareScopeView from "../components/share/FileShareScopeView.vue";
import {
  fetchUserInfo,
  noticeDownloadFolder,
  checkFileName,
  checkFile,
  queryFileNodeInfo,
  getKBInfo,
  renameFileTitle,
  createFile,
  getCreateOptions,
  getEditorMode,
  setEditorMode,
  queryFilePath,
  fetchWatermarkText,
  sendMettingEmail,
  convertTemplate,
  saveToMineTemplate,
  templateDetail,
  recognizeRisk,
  feedbackRisk } from
"@/api/h5/file";
import { exportPdfAPI, exportHTMLAPI, downloadPDFAPI } from "@/api/h5/export";
import { AGENT_ID, WEB_PATH } from "@/constants/auth";
import { goLogin } from "@/utils/auth";
import { mapState, mapActions, mapGetters } from "vuex";
import { FILE_STATUS } from "@/constants/file";
import { cookieOptions } from "@/constants/auth";
import Avatar from "../components/avatar/avatar";
import EditAvatar from "@/components/h5/editAvatar.vue";
import SelectAvatar from "@/components/h5/selectAvatar.vue";
import Socket from "../socket";
import { AUTH_DETAIL_LIST, EDITOR_MODE } from "@/constants/file";
import { setRedirectCallback } from "@/core/h5/request/index";
import { fileImgName } from "@/utils/avatar";
import axios from "axios";
import buried from "@/pages/H5/Cloud/utils/buried/index";
import CreatePopper from "../components/popper/CreatePopper.vue";
import MorePopper from "../components/popper/morePopper.vue";
import OpenPopper from "../components/popper/openPopper.vue";
import ClosePopper from "../components/popper/closePopper.vue";
import { watermark } from "toca-watermark";
import EditHistory from "./EditHistory.vue";
import UploadDialog from "../components/dialog/UploadDialog.vue";
import CheckDialog from "../components/dialog/checkNameDialog.vue";
import EmailSend from "../components/email/EmailSend.vue";
import EmailPreview from "../components/email/EmailPreview.vue";
// import FileUploader from "mpa-uploader";
import FileUploader from "../../../../utils/mpaUploader/index.js";
import { debounce } from "@/utils/lodash";
import FeedbackBtn from "../components/feedback.vue";
import Read from "../components/tip/read.vue";
import MobileHeader from "../components/drawer/mobileHeader.vue";
import { clearCookie } from "toca-sso";
import HoverContainerView from "@/pages/H5/Cloud/components/hoverDir/HoverContainerView.vue";
import BreadCrumb from "../components/breadCrumb/breadCrumb.vue";
import MettingBreadCrumb from "../components/breadCrumb/MettingBreadCrumb.vue";
import {
  saviorEventUUID,
  setSaviorConfigure,
  updateSaviorData } from
"../utils/savior";
import "@toca/toca-wiki-template/dist/style.css";
import {
  TocaWikiTemplate,
  TocaWikiCheckReminder,
  TocaWikiSensitiveTips,
  TocaWikiSensitiveBlocked } from
"@toca/toca-wiki-template";
import TemplateInfoHead from "../components/TemplateInfoHead.vue";
import { getCurrentQuery } from "@/utils/index";
import {
  getToken,
  getUserId,
  getSpaceId,
  getDeviceId } from
"../utils/userInfoUtil";
import { showAiEntry } from "../utils/AIUtil";
import CreateCopyButton from "../components/dialog/CreateCopyButton.vue";
import FileDownloadDialog from "../components/dialog/FileDownloadDialog.vue";
import DocSaveIcon from "../assets/DocSaveIcon.vue";
import FileStar from '../components/star/FileStar.vue';
import { showPreferenceSetting } from '../utils/preferenceSettingUtil';
import { mountHeadLinkShareRangeSet } from "../components/share/shareUtil";
import { TencentDocSocketEvents, downloadTencentDoc } from "./tencentOfficeExport";
import sensitiveBlockedHeader from '../components/header/sensitiveBlockedHeader.vue';
import { getFileNodePermission } from "@/api/h5/file";
import FolderOperationDialog from "../components/dialog/FolderOperationDialog.vue";

export default {
  components: {
    sensitiveBlockedHeader,
    HoverContainerView,
    FileShareView,
    Avatar,
    ApplyAuthView,
    EditAvatar,
    SelectAvatar,
    FileRecentView,
    TransferView,
    CreatePopper,
    CreateCopyButton,
    FolderOperationDialog,
    MorePopper,
    EditHistory,
    UploadDialog,
    CheckDialog,
    EmailSend,
    EmailPreview,
    FeedbackBtn,
    EditHistory,
    Read,
    FileShareScopeView,
    MobileHeader,
    BreadCrumb,
    OpenPopper,
    ClosePopper,
    MettingBreadCrumb,
    TemplateInfoHead,
    TencentOfficeView,
    FileDownloadDialog,
    DocSaveIcon,
    FileStar
  },
  data() {
    return {
      tocaWikiSensitiveTips: null,
      tocaWikiSensitiveBlocked: null,
      size: 0,
      canUpdateUrlAuth: false,
      showSetting: false,
      aiEntry: null,
      aiChat: null,
      watermarkText: "",
      showTemplate: false,
      isTemplate: false,
      saveTemplateDialogVisible: false,
      isLoading: false,
      isSafe: false,
      isOuterFile: false, //是否是考培系统
      cloudLoading: true,
      refreshFileUpload: true,
      refreshFolderUpload: true,
      fileUploader: null,
      showHistory: false,
      isWiki: false,
      isHome: false,
      editorMode: "PREVIEW",
      hideHeader: true,
      socketHeart: null,
      fileSocket: null,
      auth: null,
      riskType: null,
      message: "",
      rootId: null,
      fileId: null,
      metadata: null,
      component: null,
      isPublic: true,
      currentIndex: 0,
      fileList: [],
      loading: false,
      isFirst: true,
      showAuthManage: false,
      showAuthShare: false,
      applyAuthDialog: false,
      noAuthHideShare: false,
      owner: "",
      sameSpace: false,
      fileStatus: 0,
      addVisible: false,
      editVisible: false,
      moreVisible: false,
      logOutVisible: false,
      drawerVisible: false,
      recentVisible: false,
      reconnectVisible: false,
      isWps: false,
      isVideo: false,
      officeFileType: "",
      fileTitle: "",
      editTitle: false,
      editUser: [],
      spaceId: "",
      userId: "",
      token: "",
      onLine: navigator.onLine,
      contentType: "",
      creatorInfo: {},
      ownerInfo: {},
      typeInfo: {},
      showTransferDialog: false,
      //   headerMore: [
      //     // {
      //     //   name: '下载',
      //     //   id: 'download',
      //     //   icon: 'file-download',
      //     //   clickFn: this.onDownload,
      //     //   params: 'metadata'
      //     // },
      //     {
      //       name: "导出",
      //       id: "export",
      //       icon: "file-export",
      //     },
      //     // {
      //     // 	name: '保存版本',
      //     // 	id: 'save',
      //     // 	icon: 'file-save'
      //     // },
      //     {
      //       name: "历史版本",
      //       id: "history",
      //       icon: "file-history",
      //     },
      //     // {
      //     // 	name: '文件瘦身',
      //     // 	id: 'min',
      //     // 	icon: 'file-min'
      //     // },
      //     {
      //       name: "申请更多权限",
      //       id: "apply-auth",
      //       icon: "file-apply-auth",
      //     },
      //     {
      //       name: "打印",
      //       id: "print",
      //       icon: "file-print",
      //     },
      //   ],
      exportOptions: [
      {
        name: "PDF",
        icon: "file-pdf",
        type: "pdf"
      },
      {
        name: intl.$t("图片#!!!#src/pages/H5/Cloud/views/File.vue_1"),
        icon: "file-image",
        type: "image"
      }],

      currentExcelBar: "TabStartTab",
      wpsExcelBar: [
      {
        name: intl.$t("开始#!!!#src/pages/H5/Cloud/views/File.vue_1"),
        command: "TabStartTab"
      },
      {
        name: intl.$t("插入#!!!#src/pages/H5/Cloud/views/File.vue_1"),
        command: "TabInsertTab"
      },
      {
        name: intl.$t("数据#!!!#src/pages/H5/Cloud/views/File.vue_1"),
        command: "TabDataTab"
      },
      {
        name: intl.$t("公式#!!!#src/pages/H5/Cloud/views/File.vue_1"),
        command: "TabFormulaTab"
      },
      {
        name: intl.$t("协作#!!!#src/pages/H5/Cloud/views/File.vue_1"),
        command: "TabCooperationTab"
      },
      {
        name: intl.$t("视图#!!!#src/pages/H5/Cloud/views/File.vue_1"),
        command: "TabViewTab"
      },
      {
        name: intl.$t("效率#!!!#src/pages/H5/Cloud/views/File.vue_1"),
        command: "TabToolsTab"
      }],

      wpsDocBar: [
      {
        name: intl.$t("开始#!!!#src/pages/H5/Cloud/views/File.vue_2"),
        command: "TabStartTab"
      },
      {
        name: intl.$t("插入#!!!#src/pages/H5/Cloud/views/File.vue_2"),
        command: "TabInsertTab"
      },
      {
        name: intl.$t("审阅#!!!#src/pages/H5/Cloud/views/File.vue_1"),
        command: "TabReviewWord"
      },
      {
        name: intl.$t("视图#!!!#src/pages/H5/Cloud/views/File.vue_2"),
        command: "TabViewWord"
      },
      {
        name: intl.$t("页面#!!!#src/pages/H5/Cloud/views/File.vue_1"),
        command: "TabPageTab"
      },
      {
        name: intl.$t("效率#!!!#src/pages/H5/Cloud/views/File.vue_2"),
        command: "TabToolsTab"
      }],

      wpsPDFBar: [
      {
        name: intl.$t("开始#!!!#src/pages/H5/Cloud/views/File.vue_3"),
        command: "TabStartTab"
      },
      {
        name: intl.$t("批注#!!!#src/pages/H5/Cloud/views/File.vue_1"),
        command: "TabAnnoTab"
      },
      {
        name: intl.$t("效率#!!!#src/pages/H5/Cloud/views/File.vue_3"),
        command: "TabToolsTab"
      }],

      wpsPPTBar: [
      {
        name: intl.$t("插入#!!!#src/pages/H5/Cloud/views/File.vue_3"),
        command: "TabInsertTab"
      },
      {
        name: intl.$t("审阅#!!!#src/pages/H5/Cloud/views/File.vue_2"),
        command: "TabReviewTab"
      },
      {
        name: intl.$t("视图#!!!#src/pages/H5/Cloud/views/File.vue_3"),
        command: "TabViewTab"
      },
      {
        name: intl.$t("播放#!!!#src/pages/H5/Cloud/views/File.vue_1"),
        command: "TabPlayTab"
      },
      {
        name: intl.$t("效率#!!!#src/pages/H5/Cloud/views/File.vue_4"),
        command: "TabToolsTab"
      }],

      isMac: /Macintosh|MacIntel|MacPPC|Mac68K/.test(
        window.navigator.userAgent
      ),
      isKBDirExpandShow: false,
      routeItems: [],
      isSendedEmail: false,
      isTemplate: false,
      templateInfo: null,
      showShareScopeTip: false,
      showShareTip: false,
      folderFileCount: 0,
      checkMinder: null,
      isCanEdit: false,
      authInfos: [],
      // 是否展示敏感信息提示
      showSensitiveContentTips: false,
      // 是否展示敏感信息页面
      showSensitiveBlocked: false
    };
  },
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode,
      currentUser: (state) => state.currentUserInfo,
      fileAuth: (state) => state.fileAuth,
      isMettingDoc: (state) => state.isMettingDoc,
      docInfo: (state) => state.docInfo,
      precheckDocInfo: (state) => state.precheckDocInfo,
      cloudI18n: (state) => state.cloudI18n,
      userInfo: (state) => state.userInfo,
      tocaEditor: (state) => state.tocaEditor,
      shareAuthTip: (state) => state.shareAuthTip,
      officePreviewModeInfo: (state) => state.officePreviewModeInfo,
      wikiSpaceInfo: (state) => state.wikiSpaceInfo,
      canCreateContentTypes: (state) =>
      state.wikiSpaceInfo?.wikiSpaceSettings?.canCreateContentTypes,
      readOnly: (state) => state.wikiSpaceInfo?.wikiSpaceSettings?.readOnly
    }),
    ...mapGetters({
      containDownloadId: "containDownloadId"
    }),
    locale() {
      return this.cloudI18n || localStorage.getItem("tci18nLocale") || navigator.language || "zh-cn";
    },
    moreUserCount() {
      const userCount = this.editUser.length - 1;
      if (userCount > 99) {
        return '+99';
      }
      return `+${userCount}`;
    },
    downloadTitle() {
      if (this.isFolder === true) {
        return intl.$t("全部下载#!!!#src/pages/H5/Cloud/views/File.vue_1");
      } else {
        if (this.contentType === 'DOCUMENT') {
          return intl.$t("下载为PDF#!!!#src/pages/H5/Cloud/views/File.vue_1");
        }
      }
      return intl.$t("下载#!!!#src/pages/H5/Cloud/views/File.vue_1");
    },
    isDocMobile() {
      return !this.isPcMode && this.contentType === "DOCUMENT";
    },
    is_inTocaApp() {
      return navigator.userAgent.toLowerCase().indexOf("toca") !== -1;
    },
    isShowShareRangeSet() {
      if (this.isMettingDoc === true) {
        return false;
      }
      return this.cloudLoading === false && this.isLogin === true;
    },
    isShowCheckReminder() {
      return !this.cloudLoading && !this.isSafe && this.isPcMode && this.userId?.length > 0;
    },
    isShowSensitiveContentTips() {
      return !this.cloudLoading && this.showSensitiveContentTips;
    },
    isShowSensitiveBlocked() {
      if (this.productType === 'WIKI_FILE') {
        return !this.cloudLoading && this.showSensitiveBlocked && this.wikiSpaceInfo !== null && this.wikiSpaceInfo?.memberIdentity !== 'ADMIN';
      }
      return !this.cloudLoading && this.showSensitiveBlocked;
    },
    isTencentDoc() {
      // 是否通过企微文档预览
      if (
      this.officePreviewModeInfo &&
      this.officePreviewModeInfo.enabledOfficePreview)
      {
        return this.officePreviewModeInfo.enabledOfficePreview === true;
      }
      return false;
    },
    isSupportEdit() {
      const currentTime = new Date().getTime();
      const readOnly = this.wikiSpaceInfo?.wikiSpaceSettings?.readOnly;
      const startTime = this.wikiSpaceInfo?.wikiSpaceSettings?.
      readOnlyStartTime;
      const endTime = this.wikiSpaceInfo?.wikiSpaceSettings?.readOnlyEndTime;
      if (
      readOnly !== null &&
      readOnly !== undefined &&
      readOnly === true &&
      currentTime >= startTime &&
      currentTime <= endTime)
      {
        return false;
      }
      return (
        this.auth !== null && (
        this.auth == "WRITE" || this.auth == "ALL") &&
        this.contentType == "DOCUMENT");

    },
    showAiEntry() {
      return showAiEntry(
        this.showtype,
        this.contentType,
        this.auth,
        !this.showHistory,
        this.isLogin,
        this.isMettingDoc,
        this.isEditorPreview
      );
    },
    showtype() {
      const { showtype = "" } = getCurrentQuery() || {};
      return showtype;
    },
    isEditorPreview() {
      const isPreview = new URLSearchParams(window.location.search).get(
        "isPreview"
      );
      return isPreview === "true";
    },
    belongingFileId() {
      let belongingFileId = "";
      const ifameUrl = document.location.href;
      if (ifameUrl && ifameUrl.length > 0) {
        belongingFileId = new URLSearchParams(ifameUrl).get("belongingFileId");
      }
      return belongingFileId;
    },
    isShowTemplateInfo() {
      return (
        this.isTemplate &&
        !this.isEditorPreview &&
        this.isPcMode &&
        this.isHasAuth(this.auth));

    },
    isDir() {
      return this.precheckDocInfo.type && this.precheckDocInfo.type === "1";
    },
    isWPSOrDoc() {
      const docTypes = ["DOCUMENT", "WORD", "EXCEL", "PPT"];
      const docType = this.precheckDocInfo?.contentType;
      const isDocType =
      docType && docType.length > 0 && docTypes.includes(docType);
      return isDocType;
    },
    isWPSDoc() {
      const docTypes = ["WORD", "EXCEL", "PPT"];
      const docType = this.precheckDocInfo?.contentType;
      const isDocType = docTypes.includes(docType);
      return isDocType;
    },
    isMyDoc() {
      const creatorInfo = this.precheckDocInfo.creatorInfo;
      return (
        creatorInfo.userId === this.currentUser.userId &&
        creatorInfo.spaceId === this.currentUser.spaceId);

    },
    isShowSendEmail() {
      return this.isMettingDoc === true && this.isHasAuth(this.auth);
    },
    isShowBreadCrumb() {
      if (this.isMettingDoc === true) {
        return true;
      }
      return (
        this.routeItems.length > 0 &&
        !(this.isHome || this.isSafe || this.isMettingDoc));

    },
    showHeaderMiddle() {
      return (
        (this.officeFileType === "s" ||
        this.officeFileType === "w" ||
        this.officeFileType === "f" ||
        this.officeFileType === "p") &&
        this.isLogin &&
        this.auth &&
        this.auth !== "READ" &&
        this.auth !== "READ_DOWNLOAD" &&
        this.isTencentDoc === false);

    },
    isFolder() {
      return this.contentType == "FOLDER";
    },
    headerMiddleOptions() {
      switch (this.officeFileType) {
        case "s":
          return this.wpsExcelBar;
        case "w":
          return this.wpsDocBar;
        case "f":
          return this.wpsPDFBar;
        case "p":
          return this.wpsPPTBar;
      }
    },
    tooltipClass() {
      return this.isWiki ? "customPoperClass_wiki" : "customPoperClass";
    },
    showDownload() {
      const rid = this.$route.query.rid;
      if (!!rid && rid !== this.fileId) {
        return this.fileAuth !== "READ";
      }
      if (this.auth !== null && this.auth !== "READ") {
        if (this.isLogin === true) {
          // 登录场景,这中格式不显示，下载归拢到更多菜单了
          return (
            this.contentType !== "WORD" &&
            this.contentType !== "PPT" &&
            this.contentType !== "EXCEL" &&
            this.contentType !== "DOCUMENT");

        } else {
          return true;
        }
      }
      return false;
      //   return (
      //     this.auth !== null &&
      //     this.auth !== "READ" &&
      //     this.contentType !== "WORD" &&
      //     this.contentType !== "PPT" &&
      //     this.contentType !== "EXCEL" &&
      //     !!this.contentType &&
      //     this.contentType !== "DOCUMENT"
      //   );
    },
    showEdiTorMode() {
      return (
        this.auth !== null && (
        this.auth == "WRITE" || this.auth == "ALL") &&
        this.contentType == "DOCUMENT");

    },
    showRead() {
      return (
        this.auth !== null && (
        this.auth == "READ" || this.auth == "READ_DOWNLOAD") &&
        !this.isFolder);

    },
    isEditor() {
      return utils.isEditor(this.contentType);
    },
    moreStyle() {
      return this.isWiki || this.is_inTocaApp ? { marginLeft: 0 } : {};
    },
    isCloud() {
      return !this.is_inTocaApp;
    },
    departMentInfo() {
      return this.currentUser.departments?.
      map((item) => item.departmentName).
      join("/");
    },
    editTitlePermission() {
      return (
        this.editTitle &&
        this.isLogin &&
        this.auth !== "READ" &&
        this.auth !== "READ_DOWNLOAD");

    },
    isLogin() {
      let isLogin = false;
      if (!!this.spaceId && !!this.token && !!this.userId) {
        isLogin = true;
      }
      //KP系统
      if (
      !!this.userInfo?.spaceId &&
      !!this.userInfo?.token &&
      !!this.userInfo?.userId)
      {
        isLogin = true;
      }
      // scrm
      if (this.showtype === "sdk") {
        if (
        !!(window?.parent || { sdk_userInfo: { token: "" } })?.sdk_userInfo?.
        token)
        {
          isLogin = true;
        }
      }

      return isLogin;
    },
    fileStatusString() {
      return FILE_STATUS[this.fileStatus];
    },
    currentUserParams() {
      return { spaceId: this.spaceId, userId: this.userId };
    },
    subFileName() {
      return metadata.fileName;
    },
    showFileStatus() {
      return this.isWps && this.isLogin && this.auth !== "READ";
    },
    isFileOwner() {
      return this.ownerInfo?.userId === this.userId;
    },
    isOtherFile() {
      return !this.isWps && !this.isEditor;
    },
    showEditUserList() {
      return this.editUser.slice(0, 1);
    },
    hiddenEditUserList() {
      return this.editUser;
    },
    memberUniqueId() {
      if ("undefined" == cookies.get("memberUniqueId")) {
        return this.currentUser.id;
      }
      return cookies.get("memberUniqueId") || this.currentUser.id;
    },
    editorModeText() {
      return this.editorMode == EDITOR_MODE.edit ? intl.$t("进入阅读#!!!#src/pages/H5/Cloud/views/File.vue_1") : intl.$t("进入编辑#!!!#src/pages/H5/Cloud/views/File.vue_1");
    },
    editorIconClass() {
      return this.editorMode == EDITOR_MODE.edit ?
      "edit-read-mode" :
      "edit-write-mode";
    },
    showAdd() {
      return !this.isWiki && this.metadata?.type == 0;
    },
    showMore() {
      return this.isWps && this.$refs.headerMore.showMore();
    },
    changeRecentShow() {
      console.log("changeRecentShow");
      this.recentVisible = true;
    },
    changeRecentHide() {
      console.log("changeRecentHide");
      this.recentVisible = false;
    },
    isCloudDiskDoc() {// 是否是云盘文档
      return this.precheckDocInfo?.productType === 'CLOUD_FILE';
    }
  },
  methods: {
    ...mapActions([
    "setCurrentUserInfo",
    "setDocInfo",
    "newTasks",
    "changeTaskStatus",
    "removeTasks",
    "changeUploadSpeed",
    "changeUploadProgress",
    "setRecentViewShow",
    "setIsMettingDoc",
    "setPrecheckDocInfo",
    "setOfficePreviewModeInfo",
    "addDownloadIds",
    "removeDownloadIds",
    "setWikiSpaceInfo",
    "setShareAuthTip",
    "setIsCanCopy"]
    ),
    updateAuthInfos(authInfos) {
      this.authInfos = authInfos;
    },
    isHasAuth(auth) {
      if (auth && auth.length > 0 && auth !== 'NONE') {
        return true;
      }
      return false;
    },
    isHasReadDownloadAuth(auth) {
      if (auth && (auth === 'READ_DOWNLOAD' || auth === 'WRITE' || auth === 'ALL')) {
        return true;
      }
      return false;
    },
    updateSource(val) {
      this.folderFileCount = val && val.length || 0;
    },
    clickCreateCopy() {
      this.hideAuthAndShare();
      if (this.precheckDocInfo?.contentType === "DOCUMENT") {
        this.$refs.componentRef.save(this.$refs.folderOperationDialog?.showCopyDialog);
      } else if (this.isWPSDoc) {
        this.$refs.componentRef.
        handleSave().
        then(() => {
          setTimeout(() => {this.$refs.folderOperationDialog?.showCopyDialog();}, 1500);
        }).
        catch(() => {
          setTimeout(() => {this.$refs.folderOperationDialog?.showCopyDialog();}, 1500);
        });
      } else {
        this.$refs.folderOperationDialog?.showCopyDialog();
      }
    },
    hideAuthAndShare(isClickCheckReminder = false) {
      if (isClickCheckReminder === true) {
        setSaviorConfigure({
          expandfield: {
            source: this.isMettingDoc === true ? "meeting" : "docs"
          }
        });
        updateSaviorData({
          eventtype: "click",
          category: "cloud_document",
          label: "reminder",
          eventid: "cloud_document_operation"
        });
        setSaviorConfigure({ expandfield: {} });
      }
      if (this.showAuthManage) this.showAuthManage = false;
      if (this.showAuthShare) this.showAuthShare = false;
    },
    shareMouseEnter() {
      if (!this.showAuthManage) {
        this.showShareTip = true;
      }
    },
    shareScopeMouseEnter() {
      if (!this.showAuthShare) {
        this.showShareScopeTip = true;
      }
    },
    onSelectionUpdate(content) {
      if (this.aiEntry) {
        this.aiEntry?.onSelectionUpdate(content);
      }
    },
    onChangeEditStatus(isCanEdit) {
      this.isCanEdit = isCanEdit;
    },
    saveKbDoc() {
      if (this.precheckDocInfo?.contentType === "DOCUMENT") {
        this.$refs.componentRef.saveKbDoc();
      }
    },
    destroyAi() {
      this.aiEntry?.destroy();
      this.aiChat?.destroy();
      document.getElementById("toca-wiki-ai-chat-container")?.remove();
      document.getElementById("toca-wiki-ai-entry-container")?.remove();
      this.aiEntry = null;
      this.aiChat = null;
    },
    handleAi() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.destroyAi();
          if (this.showAiEntry) {
            this.loadWikiAiChat();
            this.loadWikiAiEntry();
          }
        });
      }, 1000);
    },
    loadWikiAiEntry() {
      const cookie = {
        token: cookies.get("token"),
        spaceId: cookies.get("spaceId"),
        userId: cookies.get("userId"),
        deviceId: cookies.get("deviceId"),
        memberUniqueId: this.memberUniqueId || this.memberId,
        memberId: cookies.get("memberId") || this.memberId
      };
      const container = document.getElementById("toca-wiki-ai-entry");
      //先执行这一行，必须先拿到cookies
      this.aiEntry = new TocaWikiAiEntry(container, cookie, {
        locale: this.cloudI18n
      });
      // 只能识别这个元素<toca-wiki-ai-entry></toca-wiki-ai-entry>
      const app = document.createElement("toca-wiki-ai-entry");
      app?.setAttribute("id", "toca-wiki-ai-entry-container");
      container?.appendChild(app);
    },
    loadWikiAiChat() {
      const container = document.getElementById("toca-wiki-ai-chat");
      // 只能识别这个元素<toca-wiki-ai-chat></toca-wiki-ai-chat>
      const app = document.createElement("toca-wiki-ai-chat");
      app?.setAttribute("id", "toca-wiki-ai-chat-container");

      this.aiChat = new TocaWikiAiChat(container, {
        env: process.env.VUE_APP_STATIC_NODE_ENV,
        wikiSpaceId: "",
        documentId: this.fileId,
        tocaEditor: this.tocaEditor,
        locale: this.cloudI18n,
        saviorEventUUID: saviorEventUUID,
        setSaviorConfigure: setSaviorConfigure,
        updateSaviorData: updateSaviorData,
        supportDocInteraction: this.precheckDocInfo?.contentType === "DOCUMENT",
        sourceFrom: this.precheckDocInfo?.contentType,
        contentElement: document.querySelector(".file-container")
      });

      container.appendChild(app);
    },
    gotoUseTemplate(templateId) {
      let that = this;
      updateSaviorData({
        eventtype: "click",
        category: "cloud_document",
        label: "new_fromTemplateDoc",
        eventid: "Template_opreation",
        value: {
          fid: that.precheckDocInfo?.fileId
        }
      });
      if (that.precheckDocInfo?.contentType === "DOCUMENT") {
        that.$refs.componentRef.save(this.$refs.folderOperationDialog?.showCreateFileWithTemplateDialog);
      } else {
        that.$refs.componentRef.
        handleSave().
        then(() => {
          setTimeout(() => {
            that.$refs.folderOperationDialog?.showCreateFileWithTemplateDialog();
          }, 1500);
        }).
        catch(() => {
          setTimeout(() => {
            that.$refs.folderOperationDialog?.showCreateFileWithTemplateDialog();
          }, 1500);
        });
      }
    },
    gotoTemplateLib(createType, fileId = "") {
      this.showTemplate = true;
      let that = this;
      this.$nextTick(() => {
        const cookie = {
          token: cookies.get("token"),
          spaceId: cookies.get("spaceId"),
          userId: cookies.get("userId"),
          deviceId: cookies.get("deviceId"),
          memberUniqueId: cookies.get("memberUniqueId") || that.currentUser.id,
          memberId: cookies.get("memberId") || that.currentUser.id
        };
        let env = process.env.VUE_APP_STATIC_NODE_ENV;
        // if (env === "qa") env = "development";

        const param = {
          env: env,
          cookies: cookie,
          isCreate: true,
          isPCMode: false,
          //   createType: [createType],
          currentCreateType: createType,
          createType:
          this.canCreateContentTypes?.length > 0 ?
          this.canCreateContentTypes :
          ["DOCUMENT", "EXCEL", "PPT", "WORD"],
          onCreateEmptyTemplate: () => {
            const ownId = that.spaceId + "_" + that.userId + "_doc";
            createFile({
              templateFileId: "",
              newFileType: createType,
              parentId: fileId || ownId, //如果有父级取父级，没有取我的文档根目录
              productType: "CLOUD_DOCUMENT"
            }).
            then((res) => {
              const { code, data } = res;
              if (code === 200) {
                if (code === 200 && data.fileId) {
                  buried.reportPoint("新建文档", "new_file");
                  if (fileId && this.isFolder) {
                    that.$refs.componentRef.refresh();
                  }
                  const { origin, pathname } = window.location;
                  window.open(
                    origin +
                    pathname +
                    "" +
                    `?fid=${data?.fileId}&type=fileCreate`,
                    "_blank"
                  );
                }
              }
              that.addVisible = false;
            }).
            catch((err) => {
              that.addVisible = false;
            });
          },
          onCloseTemplate: () => {
            that.showTemplate = false;
          },
          onUseTemplate: (template) => {
            updateSaviorData({
              eventtype: "click",
              category: "cloud_document",
              label: "new_fromTemplate",
              eventid: "Template_opreation",
              value: {
                fid: template.fileId
              }
            });
            const ownId = that.spaceId + "_" + that.userId + "_doc";
            createFile({
              templateFileId: template.fileId,
              newFileType: template.contentType,
              parentId: fileId || ownId,
              productType: "CLOUD_DOCUMENT"
            }).
            then((res) => {
              const { code, data } = res;
              if (code === 200) {
                if (code === 200 && data.fileId) {
                  buried.reportPoint("新建文档", "new_file");
                  if (fileId && this.isFolder) {
                    that.$refs.componentRef.refresh();
                  }
                  const { origin, pathname } = window.location;
                  window.open(
                    origin +
                    pathname +
                    "" +
                    `?fid=${data?.fileId}&type=fileCreate`,
                    "_blank"
                  );
                }
              }
              that.addVisible = false;
            }).
            catch((err) => {
              that.addVisible = false;
            });
          },
          locale:
          that.cloudI18n ||
          localStorage.getItem("tci18nLocale") ||
          navigatorLang[navigator.language] ||
          "zh-cn"
        };

        this.tocaWikiTemplate = new TocaWikiTemplate(
          "#toca_wiki_template_container",
          cookie,
          param
        );
      });
    },

    handleTemplateInfo() {
      let that = this;
      templateDetail(this.precheckDocInfo?.fileId).
      then((res) => {
        const { data, code } = res;
        if (code === 200) {
          that.templateInfo = data;
        }
      }).
      catch((err) => {
        console.log("------------err:", err);
      });
    },

    gotoCreateFile() {
      let that = this;
      const fileId = that.precheckDocInfo?.fileId;
      const type = that.precheckDocInfo?.contentType;
      const ownId = that.spaceId + "_" + that.userId + "_doc";

      if (!(that.userId && that.userId.length > 0)) {
        const isFromFile = window.location.href.includes(WEB_PATH.file);
        const path = isFromFile ?
        window.location.href?.split(WEB_PATH.file)[1] :
        window.location.href?.split(WEB_PATH.cloud)[1];
        goLogin(window.location.href, AGENT_ID.file);
        return;
      }

      createFile({
        templateFileId: fileId,
        newFileType: type,
        parentId: ownId,
        productType: "CLOUD_DOCUMENT"
      }).
      then((res) => {
        const { data, code } = res;
        if (code === 200 && data.fileId) {
          buried.reportPoint("新建文档", "new_file");
          const newFileId = data.fileId;
          //更新模板使用信息
          templateDetail(fileId).then((res) => {
            const { data, code } = res;
            if (code === 200) {
              this.templateInfo = data;

              const { origin, pathname } = window.location;
              const openUrl =
              origin + pathname + "" + `?fid=${newFileId}&type=fileCreate`;
              setTimeout(() => {
                window.open(openUrl, "_blank");
              }, 500);
            }
          });
        }
      }).
      catch((err) => {
        that.$message.error(intl.$t("创建文件失败#!!!#src/pages/H5/Cloud/views/File.vue_1"));
      });
    },
    updateTemplateType() {
      const docTypes = ["DOCUMENT", "WORD", "EXCEL", "PPT"];
      const docType = this.precheckDocInfo?.contentType;
      const isDocType =
      docType && docType.length > 0 && docTypes.includes(docType);
      this.isTemplate =
      this.precheckDocInfo !== null &&
      this.precheckDocInfo?.templateType !== null &&
      this.precheckDocInfo?.templateType !== 0 &&
      isDocType === true;
      //   this.$emit("updateTemplateType", this.doc_info?.fileInfo?.templateType);
    },
    async transTemplate() {
      if (this.precheckDocInfo?.contentType === "DOCUMENT") {
        this.$refs.componentRef.save(this.gotoTransTemplate);
      } else {
        const result = await this.$refs.componentRef.handleSave();
        this.gotoTransTemplate();
      }
    },
    gotoTransTemplate() {
      console.log("----transTemplate----");
      let that = this;
      if (this.isMyDoc === true) {
        convertTemplate(this.precheckDocInfo?.fileId).
        then((res) => {
          const { data, code } = res;
          if (code === 200) {
            const templateType = data;
            if (data !== 0) {
              updateSaviorData({
                eventtype: "click",
                category: "cloud_document",
                label: "set_myDoc",
                eventid: "Template_opreation",
                value: {
                  fid: that.precheckDocInfo?.fileId
                }
              });
              that.$message.success(intl.$t("转换成功,可一键使用或分享#!!!#src/pages/H5/Cloud/views/File.vue_1"));
            }
            let newDocInfo = JSON.parse(JSON.stringify(that.precheckDocInfo));
            newDocInfo.templateType = templateType;
            that.setPrecheckDocInfo(newDocInfo);
            that.updateTemplateType();
          } else {
            console.log("---------转换失败:", code);
            const templateType = that.precheckDocInfo.templateType;
            if (templateType !== 0) {
              that.$message.error(intl.$t("取消失败#!!!#src/pages/H5/Cloud/views/File.vue_1"));
            } else {
              that.$message.error(intl.$t("转换失败#!!!#src/pages/H5/Cloud/views/File.vue_1"));
            }
          }
        }).
        catch((err) => {
          console.log("---------转换失败:", err);
          const templateType = that.precheckDocInfo.templateType;
          if (templateType !== 0) {
            that.$message.error(intl.$t("取消失败#!!!#src/pages/H5/Cloud/views/File.vue_2"));
          } else {
            that.$message.error(intl.$t("转换失败#!!!#src/pages/H5/Cloud/views/File.vue_2"));
          }
        });
      } else {
        that.saveToTemplate();
      }
    },
    templateSwitchChange(value) {
      console.log("----templateSwitchChange----");
      this.transTemplate();
    },
    clickToSaveTemplate() {
      let that = this;
      saveToMineTemplate(that.precheckDocInfo?.fileId).
      then((res) => {
        const { data, code, message } = res;
        that.saveTemplateDialogVisible = false;
        if (code === 200) {
          updateSaviorData({
            eventtype: "click",
            category: "cloud_document",
            label: "set_otherDoc",
            eventid: "Template_opreation",
            value: {
              fid: that.precheckDocInfo?.fileId
            }
          });
          that.$message.success(intl.$t("保存成功#!!!#src/pages/H5/Cloud/views/File.vue_1"));
          setTimeout(() => {
            const fileUrl = data.fileUrl;
            window.open(fileUrl, "_blank");
          }, 500);
        } else {
          that.$message.error(message);
        }
      }).
      catch((err) => {
        that.saveTemplateDialogVisible = false;
        that.$message.error(intl.$t("保存失败#!!!#src/pages/H5/Cloud/views/File.vue_1"));
      });
    },
    saveToTemplate() {
      this.saveTemplateDialogVisible = true;
    },
    handleEditorFocus() {
      const editor = window.editor;
      if (!editor) return;
      const selection = editor.state?.selection;
      if (!selection) return;
      editor.commands?.setTextSelection(0);
    },
    gotoSendEmail() {
      this.$refs.componentRef.save(this.startSendEmail);
    },
    startSendEmail() {
      this.isSendedEmail = false;
      this.handleEditorFocus();
      setTimeout(() => {
        this.$refs.emailSend.handleEmailSendDialog(true);
      }, 100);
    },
    async sendEmail(data) {
      updateSaviorData({
        eventtype: "click",
        category: "cloud_document",
        label: "send_mail",
        eventid: "cloud_document_operation"
      });
      if (data.emailSubject.length <= 0) {
        this.$message.error(intl.$t("请填写邮件主题#!!!#src/pages/H5/Cloud/views/File.vue_1"));
        return;
      }
      if (
      data.toCreator === false &&
      data.toJoinUser === false &&
      data.toOutsiders.length === 0 &&
      data.toFileId.length <= 0)
      {
        this.$message.error(intl.$t("收件人不能为空#!!!#src/pages/H5/Cloud/views/File.vue_1"));
        return;
      }

      const htmlStr = window.editor.view.dom.outerHTML;
      this.isLoading = true;
      const htmlTemplate = await exportHTMLAPI(
        {
          fid: this.fileId,
          baseUrl: window.location.origin || "https://toca.qa.17u.cn",
          source: "cloud",
          fileName: this.metadata.fileName,
          message: this.$message,
          isPublic: this.isPublic,
          userId: this.userId,
          spaceId: this.spaceId,
          isPreview: false
        },
        this.handleLogOut
      );
      console.log(
        "--------------------------------htmlTemplate:",
        htmlTemplate
      );

      const newData = {
        ...data,
        emailBody: htmlTemplate
      };
      console.log("---------------------data:", newData);
      sendMettingEmail(newData, this.fileId).
      then((res) => {
        console.log("-----------------res:", res);
        if (this.$refs.emailPreview) {
          this.$refs.emailPreview.handleEmailPreviewDialog(false);
        }
        this.$refs.emailSend.handleEmailSendDialog(false);
        this.isSendedEmail = true;
        this.isLoading = false;
        this.$message({
          duration: 1000,
          type: "success",
          message: intl.$t(`邮件发送成功#!!!#src/pages/H5/Cloud/views/File.vue_1`)
        });
      }).
      catch((err) => {
        this.isLoading = false;
        this.$message.error(intl.$t("邮件发送失败,请重试#!!!#src/pages/H5/Cloud/views/File.vue_1"));
      });
    },
    closeSend() {
      this.isSendedEmail = true;
    },
    async previewEmail(data) {
      this.isLoading = true;
      const htmlTemplate = await exportHTMLAPI(
        {
          fid: this.fileId,
          baseUrl: window.location.origin || "https://toca.qa.17u.cn",
          source: "cloud",
          fileName: this.metadata.fileName,
          message: this.$message,
          isPublic: this.isPublic,
          userId: this.userId,
          spaceId: this.spaceId,
          isPreview: true
        },
        this.handleLogOut
      );
      console.log(
        "--------------------------------htmlTemplate:",
        htmlTemplate
      );
      this.isLoading = false;
      if (htmlTemplate.length <= 0) {
        this.$message.error(intl.$t("邮件预览失败,请重试#!!!#src/pages/H5/Cloud/views/File.vue_1"));
        return;
      }
      this.$refs.emailPreview.handleEmailPreviewDialog(true);
      this.$refs.emailPreview.updatePreviewHtml(htmlTemplate);
      this.$refs.emailPreview.updateEmailData(data);
    },
    async backToSend() {
      this.$refs.emailPreview.handleEmailPreviewDialog(false);
    },
    goToHomePage() {
      let baseURL = process.env.VUE_APP_WIKI_URL;
      window.open(`https:${baseURL}`, "_blank");
    },
    handleShowHistory(value) {
      this.showHistory = value;
    },
    updateEditorWidth(value) {
      if (this.$refs.componentRef.updateEditorWidth) {
        this.$refs.componentRef.updateEditorWidth(value);
      }
    },
    async onEditorModeChange() {
      if (this.isSupportEdit === false) return;
      try {
        const mode =
        this.editorMode == EDITOR_MODE.edit ?
        EDITOR_MODE.preview :
        EDITOR_MODE.edit;
        const data = {
          settingsCode: "FILE.PAGE_READ_MODE",
          settingsValue: mode
        };
        await setEditorMode(data, this.fileId);
        this.editorMode = mode;
      } catch {}
    },
    async fetchEditorMode(productType, contentType, fileId) {
      if (
      (this.auth == "ALL" || this.auth == "WRITE") &&
      this.contentType == "DOCUMENT")
      {
        try {
          const { code = "", data = {} } = await getEditorMode({
            fid: fileId,
            settingsCode: "FILE.PAGE_READ_MODE"
          });
          if (code == 200) {
            if (this.isPcMode) {
              // 非移动端才默认进入编辑态，移动端处非创建外默认都是阅读态
              this.editorMode = data?.settingsValue;
            }
          }
        } catch {}
      } else {
        this.editorMode = EDITOR_MODE.preview;
      }

      // 请求知识库信息
      if (productType === "WIKI_FILE") {
        getKBInfo(fileId).then((res) => {
          if (res.code === 200) {
            this.setWikiSpaceInfo(res.data.wikiSpaceInfo);
            if (contentType === "DOCUMENT") {
              const currentTime = new Date().getTime();
              const readOnly = this.wikiSpaceInfo?.wikiSpaceSettings?.readOnly;
              const startTime = this.wikiSpaceInfo?.wikiSpaceSettings?.
              readOnlyStartTime;
              const endTime = this.wikiSpaceInfo?.wikiSpaceSettings?.
              readOnlyEndTime;
              if (
              readOnly === true &&
              currentTime >= startTime &&
              currentTime <= endTime)
              {
                this.editorMode = EDITOR_MODE.preview;
              }
            }
          }
        });
      }
    },
    handleTitleChange(e) {
      if (e.target.value.length > 100) {
        this.$message.error(intl.$t("字数超出限制#!!!#src/pages/H5/Cloud/views/File.vue_1"));
        return;
      }
      this.fileTitle = e.target.value;
    },
    handleWpsTab(options) {
      this.currentExcelBar = options.command;
      this.$refs.componentRef.handleWPSBarExecute(options.command);
    },
    handleViewVisible(val) {
      const view = document.querySelector("#water-mark-show");
      view.style.display = val;
    },
    handleMobileSignOut() {
      this.drawerVisible = true;
    },
    handleInitAvatar() {
      // && !this.isPcMode
      if (this.isLogin) {
        fetchUserInfo({
          spaceId: this.spaceId,
          userId: this.userId
        }).
        then((res) => {
          if (res.code === 200) {
            const avatarInfo = JSON.parse(res.data.memberAvatar);
            this.setCurrentUserInfo({
              ...res.data,
              deviceId: getDeviceId(this.showtype) || "",
              memberAvatar: avatarInfo[300]
            });
            //   console.log("-------------------userInfo:", this.userInfo);
            if (res.data.id) {
              cookieOptions.map((item) => {
                cookies.set("memberId", res.data.id, item);
              });
            }
            if (
            this.isLogin &&
            res.data?.employeeNo &&
            res.data?.memberName)
            {
              // setTimeout(() => {
              watermark.set(
                this.watermarkText =
                res.data?.memberName + " " + res.data?.employeeNo,
                "water-mark-show",
                "water-mark-cloud",
                "calc(100vh - 54px)"
              );
              // }, 500)
            }
          }
        }).
        catch((err) => {
          console.log("-------err:", err);
        });
      } else {
        if (!(this.fileId && this.fileId.length > 0)) {
          return;
        }
        fetchWatermarkText(this.fileId).
        then((res) => {
          if (res.data) {
            watermark.set(
              this.watermarkText = res.data,
              "water-mark-show",
              "water-mark-cloud",
              "calc(100vh - 54px)"
            );
          } else {
            watermark.set(
              this.watermarkText = intl.$t("同程管家#!!!#src/pages/H5/Cloud/views/File.vue_1"),
              "water-mark-show",
              "water-mark-cloud",
              "calc(100vh - 54px)"
            );
          }
        }).
        catch(() => {
          watermark.set(
            this.watermarkText = intl.$t("同程管家#!!!#src/pages/H5/Cloud/views/File.vue_2"),
            "water-mark-show",
            "water-mark-cloud",
            "calc(100vh - 54px)"
          );
        });
      }
    },
    async handleLogOut(showMessage = true) {
      if (this.$route.query?.source === "wiki") {
        await clearCookie(process.env.VUE_APP_BASE_URL);
        window.parent.postMessage("logout", "*");
        // window?.parent?.window?.location.reload();
        return;
      }

      if (!this.isPublic) {
        goLogin(window.location.href, AGENT_ID.file, true);
        return;
      } else {
        await clearCookie(process.env.VUE_APP_BASE_URL);
        if (this.isEditor) {
          window?.parent?.window?.location.reload();
        }
      }

      this.handleInitCookies();
      this.logOutVisible = false;
      this.drawerVisible = false;
      if (showMessage) {
        this.$message.success(intl.$t("退出成功#!!!#src/pages/H5/Cloud/views/File.vue_1"));
      }

      this.message = "";
      this.component = MessageView;
      this.hideHeader = false;

      await this.redirect(); // 退出登录后，如果该文件为非公开链接，则跳转登录页
      this.loading = false;
      //   setTimeout(() => {
      //     window.location.reload();
      //   }, 100);
    },
    handleInitExportOptions(fileType) {
      this.officeFileType = fileType;
      switch (fileType) {
        case "w":
          break;
        case "s":
          const newValue = this.exportOptions.filter(
            (item) => item?.type !== "pdf"
          );
          this.exportOptions = newValue;
          break;
        case "p":
          this.currentExcelBar = "TabInsertTab";
          break;
        default:
          break;
      }
    },
    async handleChangeWikiTitle(data) {
      if (!data) {
        this.$message.error(intl.$t("文件名称不能为空#!!!#src/pages/H5/Cloud/views/File.vue_1"));
        return;
      }
      if (data === this.metadata?.fileName) {
        return;
      }
      const res = await renameFileTitle({
        fileId: this.metadata?.fileId,
        fileName: data,
        parentId: this.metadata?.parentId
      });
      if (res.code === 200) {
        if (this.contentType === "DOCUMENT") {
          this.$refs.componentRef.updateDocInfo({ fileName: res.data?.fileName });
        }
        this.metadata.fileName = res.data?.fileName;
        document.title = res.data?.fileName;
      } else {
        console.log("----------------------filename:", this.metadata.fileName);
        this.fileTitle = utils.getFileName(this.metadata.fileName);
        console.log(
          "----------------------filename:",
          this.fileTitle,
          this.$refs.componentRef
        );
        if (this.contentType === "DOCUMENT") {
          this.$refs.componentRef.updateDocInfo({ fileName: this.fileTitle });
        }
        if (res.message && res.message.length > 0) {
          this.$message.error(res.message);
        }
      }
    },
    handleInputBlur() {
      this.$refs.titleInput.blur();
    },
    async handleSaveTitle() {
      if (!this.fileTitle) {
        this.$message.error(intl.$t("文件名称不能为空#!!!#src/pages/H5/Cloud/views/File.vue_2"));
        return;
      }
      this.editTitle = false;
      const noExt =
      this.metadata?.type !== "0" || this.contentType === "DOCUMENT";
      const fileType = noExt ? "" : utils.getExt(this.metadata?.fileName);
      const fileNameContent =
      this.fileTitle +
      `${
      this.metadata?.type !== "0" || this.contentType === "DOCUMENT" ?
      "" :
      "."}` +

      fileType;
      if (fileNameContent == this.metadata.fileName) {
        return;
      }
      const res = await renameFileTitle({
        fileId: this.metadata?.fileId,
        fileName: fileNameContent,
        parentId: this.metadata?.parentId
      });
      if (res.code === 200) {
        if (this.contentType === "DOCUMENT" || this.metadata?.type !== "0") {
          this.$refs.componentRef.updateDocInfo({ fileName: res.data?.fileName });
        }
        this.metadata.fileName = res.data?.fileName;
        document.title = res.data?.fileName;
      } else {
        this.fileTitle = utils.getFileName(this.metadata.fileName);
        if (res.message && res.message.length > 0) {
          this.$message.error(res.message);
        }
      }
    },
    handleCreate(type, fileId = "") {
      this.gotoTemplateLib(type, fileId);
    },
    handleExportPDFTransfrom() {
      this.handleExportPDF(this.metadata);
    },
    onMorePopperShow() {
      this.handleCloseShareView();
    },
    async handleMore(options) {
      this.moreVisible = false;
      if (this.showAuthManage) {
        this.showAuthManage = false;
      }
      if (this.showAuthShare) {
        this.showAuthShare = false;
      }
      switch (options.id) {
        case "download":
          this.onDownload(this.metadata.fileId);
          break;
        case "export":
          // if (this.$refs.exportPopper.style.display !== 'none') {
          //   this.$refs.exportPopper.style.display = 'none';
          // } else {
          //   console.log("this.$refs.exportPopper.style.display === 'none'");
          //   this.$refs.exportPopper.style.display = 'flex';
          // }
          break;
        case "tocaeditor-fullscreen":
          this.$refs.componentRef.requestFullscreen();
          break;
        case "export-wiki":
          console.log("handle export-wiki");
          this.$refs.componentRef.save(this.handleExportPDFTransfrom);
          break;
        case "print":
          this.handlePrint();
          buried.reportPoint("打印", "more_print");
          break;
        case "history":
          if (this.contentType === "DOCUMENT") {
            this.handleShowHistory(true);
            return;
          }
          this.$refs.componentRef.handleHistory();
          buried.reportPoint("历史版本", "more_history");
          break;
        // case 'save':
        // 	this.$refs.componentRef.handleSave()
        // 	break
        case "transfer":
          this.showTransferDialog = true;
          break;
        case "apply-auth":
          this.message = intl.$t("申请更多权限#!!!#src/pages/H5/Cloud/views/File.vue_1");
          this.applyAuthDialog = true;
          break;
        case "setting":
          this.showSetting = true;
          showPreferenceSetting(
            this.currentUser,
            this.isEditor,
            this.isLogin,
            this.fileId,
            this.cloudI18n,
            () => {
              this.showSetting = false;
            },
            (fullScreenType) => {
              let isFullWidth = false;
              if (fullScreenType === 'UNLIMITED') {
                isFullWidth = true;
              }
              if (this.$refs.componentRef.updateEditorWidth) {
                this.$refs.componentRef.updateEditorWidth(isFullWidth);
              }
            },
            (linkShareRange) => {
              console.log("--------------onUpdateLinkShareRange:", linkShareRange);
            }
          );
          break;
        case "move":
          if (this.isWiki) {
            window.parent.postMessage("moveFile", "*");
            return;
          }
          this.hideAuthAndShare();
          if (this.precheckDocInfo?.contentType === "DOCUMENT") {
            this.$refs.componentRef.save(this.$refs.folderOperationDialog?.showMoveDialog);
          } else if (this.isWPSDoc) {
            this.$refs.componentRef.
            handleSave().
            then(() => {
              setTimeout(() => {this.$refs.folderOperationDialog?.showMoveDialog();}, 1500);
            }).
            catch(() => {
              setTimeout(() => {this.$refs.folderOperationDialog?.showMoveDialog();}, 1500);
            });
          } else {
            this.$refs.folderOperationDialog?.showMoveDialog();
          }
          break;
        case "copy":
          if (this.isWiki) {
            window.parent.postMessage("createCopy", "*");
            return;
          }
          this.hideAuthAndShare();
          if (this.precheckDocInfo?.contentType === "DOCUMENT") {
            this.$refs.componentRef.save(this.$refs.folderOperationDialog?.showCopyDialog);
          } else if (this.isWPSDoc) {
            this.$refs.componentRef.
            handleSave().
            then(() => {
              setTimeout(() => {this.$refs.folderOperationDialog?.showCopyDialog();}, 1500);
            }).
            catch(() => {
              setTimeout(() => {this.$refs.folderOperationDialog?.showCopyDialog();}, 1500);
            });
          } else {
            this.$refs.folderOperationDialog?.showCopyDialog();
          }
          break;
        case "delete":
          this.$refs.headerMore.handleDelete();
          break;
        case "saveToTemplate":
          this.saveToTemplate();
          break;
        case "transToTemplate":
          this.templateSwitchChange();
          break;
        default:
          break;
      }
    },
    handleExportPDF: debounce(async function (item) {
      // 轻文档下载为pdf
      try {
        const { fileId, fileName } = item;
        console.log("开始导出");
        const res = await exportPdfAPI(
          fileId,
          fileName,
          {
            spaceId: getSpaceId(this.showtype) || "",
            userId: getUserId(this.showtype) || "",
            token: getToken(this.showtype) || "",
            deviceId: getDeviceId(this.showtype) || this.fileSocket.deviceId || ""
          },
          this.handleLogOut,
          this.$message
        );
        if (res.status === 200 && res?.data?.code === 200) {
          this.$message({
            type: "success",
            message: intl.$t(`生成中...#!!!#src/pages/H5/Cloud/views/File.vue_1`)
          });
          this.addDownloadIds(res?.data?.data?.downloadId);
        } else if (res.status === 401) {
          this.handleLogOut();
          return;
        } else if (res.data.code === 9000) {
          const employeeNo = item?.creatorInfo?.employeeNo || '';
          let userName = item?.creator;
          userName = userName + '(' + employeeNo + ')';
          this.$message.error(intl.$t(`该文件存在潜在安全风险，暂不支持下载，请联系文件所有者 {userName} 处理#!!!#src/pages/H5/Cloud/views/File.vue_1`, { userName: userName }));
          return;
        } else {
          this.$message.error(intl.$t("文件生成失败#!!!#src/pages/H5/Cloud/views/File.vue_1"));
        }
      } catch {
        this.$message.error(intl.$t(`文件生成失败#!!!#src/pages/H5/Cloud/views/File.vue_2`));
      }
    }, 1000),
    handleHiddenExport() {

      // this.$refs.exportPopper.style.display = 'none';
    }, async handleFolderUpload(event) {
      const target = event.target;
      let files = Array.from(target.files);
      const folderName = files[0].webkitRelativePath.split("/")[0];
      if (this.metadata.productType === "CLOUD_DOCUMENT") {
        const suffix = [".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".pdf"];
        files = files.filter((file) => {
          const fileName = file.name.toLowerCase();
          return suffix.some((s) => fileName.endsWith(s));
        });
      }
      const { newFileName = "", type } = await this.checkUploadFile(
        "folder",
        folderName
      );
      const ownId = this.spaceId + "_" + this.userId + "_doc";
      const pid = this.isFolder ? this.fileId : ownId;
      if (newFileName) {
        this.$refs.check.handleCheckDialog(true, {
          fileName: folderName,
          newFolderName: newFileName,
          type,
          files,
          pid
        });
      } else {
        const task = this.fileUploader.addFolder(files, pid);
      }
      this.refreshFolderUpload = false;
      setTimeout(() => {
        this.refreshFolderUpload = true;
      }, 200);
    },
    folderUploadChange(files, pid, type) {
      const task = this.fileUploader.addFolder(files, pid, type);
    },
    async handleFileUpload(event) {
      const target = event.target;
      let files = Array.from(target.files);
      const fileName = files[0].name;
      if (this.metadata.productType === "CLOUD_DOCUMENT") {
        const suffix = [".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".pdf"];
        files = files.filter((file) => {
          const tmpFileName = file.name.toLowerCase();
          return suffix.some((s) => tmpFileName.endsWith(s));
        });
      }
      const { newFileName = "", type } = await this.checkUploadFile(
        "file",
        fileName
      );
      const ownId = this.spaceId + "_" + this.userId + "_doc";
      const pid = this.isFolder ? this.fileId : ownId;
      if (newFileName) {
        this.$refs.check.handleCheckDialog(true, {
          fileName,
          type,
          files,
          pid
        });
      } else {
        const task = this.fileUploader.addFiles(files, pid);
      }
      this.refreshFileUpload = false;
      setTimeout(() => {
        this.refreshFileUpload = true;
      }, 200);
    },
    fileUploadChange(files, pid, type) {
      const task = this.fileUploader.addFiles(files, pid, type);
    },
    async checkUploadFile(type, fileName) {
      let parentId = this.spaceId + "_" + this.userId + "_doc";
      if (this.isFolder) {
        parentId = this.fileId;
      }
      const {
        code,
        data: { nameList }
      } = await checkFileName({
        parentId,
        nameList: [{ fileName, type: type == "file" ? "0" : "1" }]
      });
      return nameList[0] || {};
    },
    async handleUpload(type) {
      // this.$refs.uploadDialog.showUploadDialog(true)
      switch (type) {
        case "file":
          this.$refs.fileInput.click();
          break;
        case "folder":
          this.$refs.folderInput.click();
          break;
        default:
          break;
      }
    },
    async handleExport(type) {
      this.$message({
        duration: 20000,
        type: "success",
        message: intl.$t(`生成中...#!!!#src/pages/H5/Cloud/views/File.vue_2`)
      });
      if (type === "WORD" || type === "PPT" || type === "EXCEL") {
        if (this.isTencentDoc) {
          const requestPath = `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD}/stream/api/public/export/create/${this.fileId}`;
          const response = await fetch(requestPath, {
            method: 'POST',
            headers: {
              DeviceType: '3',
              'Content-Type': 'application/json',
              token: this.token,
              userId: this.userId,
              spaceId: this.spaceId,
              deviceId: getDeviceId(this.showtype) || ""
            },
            body: JSON.stringify({
              exportFormat: type === 'pdf' ? 'PDF' : 'ORIGINAL'
            })
          });
          if (!response.ok) {
            this.$message.error(intl.$t("导出失败，请重试#!!!#src/pages/H5/Cloud/views/File.vue_1"));
            return;
          }

          const data = await response.json();
          if (data.code !== 200) this.$message.error(intl.$t("导出失败，请重试#!!!#src/pages/H5/Cloud/views/File.vue_2"));
          this.addDownloadIds(this.fileId);
        } else {
          const result = await this.$refs.componentRef.handleSave();
          try {
            // const url = `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD_URL}/public/download/${this.fileId}`;
            // window.open(url, "_blank");
            const link = document.createElement("a");
            link.href = `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD_URL}/public/download/${this.fileId}`;
            link.setAttribute("download", this.metadata.fileName);
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              document.body.removeChild(link);
            }, 1000);
            this.$message.closeAll();
            switch (type) {
              case "WORD":
                buried.reportPoint("导出本地doc", "more_export_doc");
                break;
              case "PPT":
                buried.reportPoint("导出本地ppt", "more_export_ppt");
                break;
              case "EXCEL":
                buried.reportPoint("导出本地excel", "more_export_excel");
                break;
            }
          } catch (error) {
            this.$message.error(intl.$t("导出失败，请重试#!!!#src/pages/H5/Cloud/views/File.vue_3"));
          }
        }
      } else {
        await this.$refs.componentRef.handleSave();
        this.$refs.componentRef.handleExport(type);
        switch (type) {
          case "pdf":
            buried.reportPoint("导出pdf", "more_export_pdf");
            break;
          case "image":
            buried.reportPoint("Fxg导出图片", "more_export_img");
            break;
        }
      }
    },
    handlePrint() {
      this.$refs.componentRef.handlePrint();
    },
    handleEditTitle() {
      if (
      !(this.isLogin && this.auth !== "READ" && this.auth !== "READ_DOWNLOAD"))
      {
        return;
      }
      this.editTitle = true;
      setTimeout(() => {
        this.$refs.titleInput.focus();
      });
    },
    handleFileStatus(fileInfo) {
      this.fileStatus = fileInfo?.status || 0;
    },
    loadSuccess() {
      this.loading = false;
    },
    imgPreviewDestory() {
      this.loading = false;
    },
    onDownload: debounce(async function (fileId, downFolder = false) {
      try {
        const passwordKey = `${this.rootId}-code`;
        const password = cookies.get(passwordKey) || "";
        const fileData = await checkFile(fileId, password);
        let size = fileData.data?.fileInfo?.size || 0;
        if (fileData.code === 200 && size > 100 * 1024 * 1024) {
          this.$refs.downloadRef.handleDownloadDialogVisible(
            true,
            fileData.data?.fileInfo,
            this.isFolder && downFolder
          );
        } else {
          if (this.isFolder && downFolder) {
            this.gotoDownloadFolder(fileId);
          } else {
            if (fileData.code === 200) {
              const riskType = fileData.data?.riskType || '';
              const isHIGH = riskType === 'HIGH' || riskType === 'MEDIUM' || riskType === 'LOW';
              if (isHIGH === true && fileData.data?.fileInfo?.creatorInfo?.userId !== this.currentUser?.userId) {
                const employeeNo = fileData.data?.fileInfo?.creatorInfo?.employeeNo || '';
                let userName = fileData.data?.fileInfo?.creator;
                userName = userName + '(' + employeeNo + ')';
                this.$message.error(intl.$t(`该文件存在潜在安全风险，暂不支持下载，请联系文件所有者 {userName} 处理#!!!#src/pages/H5/Cloud/views/File.vue_2`, { userName: userName }));
                return;
              }
            }
            this.gotoDownloadFile(fileId);
          }
        }
      } catch (err) {
        this.$message({
          duration: 1000,
          type: "success",
          message: intl.$t(`下载失败#!!!#src/pages/H5/Cloud/views/File.vue_1`)
        });
        console.log("下载失败原因", err);
      }
    }),
    async gotoDownloadFolder(fileId) {
      const result = await noticeDownloadFolder(
        fileId,
        this.fileSocket?.deviceId
      );
      if (result.code === 200) {
        this.$message({
          duration: 1000,
          type: "success",
          message: intl.$t(`下载中...#!!!#src/pages/H5/Cloud/views/File.vue_1`)
        });
      } else if (result.code === 9000) {
        const passwordKey = `${this.rootId}-code`;
        const password = cookies.get(passwordKey) || "";
        const fileData = await checkFile(fileId, password);
        const employeeNo = fileData?.data?.fileInfo?.creatorInfo?.employeeNo || '';
        let userName = fileData?.data?.fileInfo?.creator;
        userName = userName + '(' + employeeNo + ')';
        this.$message.error(intl.$t(`该文件存在潜在安全风险，暂不支持下载，请联系文件所有者 {userName} 处理#!!!#src/pages/H5/Cloud/views/File.vue_3`, { userName: userName }));
      } else {
        this.$message.error(result?.message || intl.$t("下载失败#!!!#src/pages/H5/Cloud/views/File.vue_2"));
      }
    },
    gotoDownloadFile(fileId) {
      if (this.contentType === 'DOCUMENT') {
        this.handleExportPDF(this.metadata);
        return;
      }
      this.$message({
        duration: 1000,
        type: "success",
        message: intl.$t(`下载中...#!!!#src/pages/H5/Cloud/views/File.vue_2`)
      });
      const key = `${this.rootId}-code`;
      const pass = cookies.get(key) || "";
      const url = `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD_URL}/public/download/${fileId}?rootId=${this.rootId}&password=${pass}`;
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("target", "_self");
      document.body.appendChild(link);
      link.click();
      setTimeout(() => document.body.removeChild(link), 200);
      buried.reportPoint("下载", "more_download");
    },
    gotoDownloadFromBrowser(fileId, isFolder) {
      if (isFolder === true) {
        this.gotoDownloadFolder(fileId);
      } else {
        this.gotoDownloadFile(fileId);
      }
    },
    openItem(item) {
      this.$router.push({
        name: "home",
        query: {
          fid: item.fileId,
          // rootId 在目录切换过程中，都为固定值，因此新增一个参数用于防止目录切换过程中页面刷新时，rootId获取不到的问题
          rid: this.rootId,
          ...item
        }
      });
    },

    passwordCommit(code) {
      this.message = "";
      const key = `${this.rootId}-code`;
      cookies.set(key, code);
      this.redirect();
      this.handleInitAvatar();
    },

    handleGoDownload() {
      this.loading = false;
      this.component = DownloadView;
    },
    async redirect() {
      const key = `${this.rootId}-code`;
      const password = cookies.get(key) || "";
      if (!this.isFirst) {
        this.loading = true;
      } else {
        this.isFirst = false;
      }

      // 处理端内打开自动登录逻辑
      const client = this.$route.query?.client || "";
      if (client && !this.isLogin) {
        cookieOptions.map((item) => {
          cookies.set("client", client, item);
        });

        this.handleLogin();
      }
      try {
        this.cloudLoading = true;
        let e = { code: "", data: {}, message: "" };
        if (this.fileId && this.fileId.length > 0) {
          e = await checkFile(this.fileId, password);
          try {
            // 获取是否可以复制权限
            const copyAuthResponse = await getFileNodePermission(this.fileId);
            if (copyAuthResponse.code === 200) {
              const { canCopyEntity } = copyAuthResponse.data;
              this.setIsCanCopy(canCopyEntity);
            }
          } catch (error) {
            this.$message.error(intl.$t("获取复制权限失败#!!!#src/pages/H5/Cloud/views/File.vue_1"));
            console.error(intl.$t("获取复制权限失败#!!!#src/pages/H5/Cloud/views/File.vue_2"), error);
          }
        }
        // this.loading = false
        const { code = "", data = {}, message = "" } = e;
        // console.log('文件前置检查：', e);
        switch (code) {
          case 200:
            const { fileInfo, isPublic, auth, officePreviewModeInfo, riskType } = data;
            this.riskType = riskType || '';

            this.size = fileInfo?.size || 0;
            //企微文档逻辑
            this.setOfficePreviewModeInfo(officePreviewModeInfo);
            this.setPrecheckDocInfo(fileInfo);
            this.updateTemplateType();
            this.owner = fileInfo.creator ?? "";
            this.isPublic = isPublic;
            this.auth = auth;
            setTimeout(() => {
              this.hideHeader = false;
            }, 200);
            this.metadata = fileInfo;
            const { fileName, type, contentType, creatorInfo, productType = "" } = this.metadata;
            if (productType === "SAFE_SPACE_FILE" || productType === "OUTER_FILE_KP" || productType === "OUTER_FILE_KF") {
              this.isSafe = true;
            }
            if (productType === "OUTER_FILE_KP" || productType === "OUTER_FILE_KF") {
              this.isOuterFile = true;
            }
            this.contentType = type === "0" ? contentType : "FOLDER";
            if (productType === "NEW_MEETING_MINUTES") {
              this.setIsMettingDoc(true);
            }
            this.creatorInfo = creatorInfo;
            this.typeInfo = { type: this.contentType, productType: productType };
            this.fetchEditorMode(productType, contentType, this.fileId);
            this.changeFavicon(this.contentType, fileName);
            // 如果isPublic为false，说明未开启互联网访问，必须登录，登录方式为强制登录/快速登录
            if (isPublic === false) {
              if (this.isLogin) {
                // 登录后，空间不相同，则无法查看
                this.sameSpace = this.spaceId === fileInfo.spaceId;
                // if (!this.sameSpace) {
                //   this.loading = false;
                //   this.message = "没有访问权限";
                //   this.component = ApplyAuthView;
                //   return;
                // }

                // 空间相同，但没有开启互联网访问也没有权限，则申请权限
                if (
                !this.isHasAuth(auth) &&
                this.isEditorPreview === false)
                {
                  this.loading = false;
                  if (this.isPcMode) {
                    this.noAuthHideShare = true;
                    this.message = intl.$t("没有访问权限#!!!#src/pages/H5/Cloud/views/File.vue_2");
                    this.component = ApplyAuthView;
                  } else {
                    this.message = intl.$t("没有权限查看#!!!#src/pages/H5/Cloud/views/File.vue_1");
                    this.component = ApplyAuthView;
                  }
                  return;
                }
                this.noAuthHideShare = false;
              } else {
                cookieOptions.map((item) => {
                  cookies.remove("userId", item);
                  cookies.remove("token", item);
                  cookies.remove("spaceId", item);
                  cookies.remove("client", item);
                });
                clearCookie(process.env.VUE_APP_BASE_URL);
                cookieOptions.map((item) => {
                  cookies.set("client", client, item);
                });
                this.loading = false;
                this.handleLogin();
                return;
              }
            } else {
              if (this.isLogin) {
                this.sameSpace = this.spaceId === fileInfo.spaceId;
              }
            }

            // 判定是否是为包含敏感信息的高风险页面（非所有者查看提示缺省页，所有者查看提示顶部横幅（SensitiveContentTips））
            const creatorId = fileInfo?.creatorInfo?.userId;
            if (riskType === 'HIGH' || riskType === 'MEDIUM' || riskType === 'LOW') {
              if (creatorId === this.userId) {
                this.showSensitiveContentTips = true;
                this.showSensitiveBlocked = false;
              } else {
                // 展示缺省页
                this.showSensitiveBlocked = true;
                this.showSensitiveContentTips = false;
                this.hideHeader = true; // 隐藏原来的头部
                const employeeNo = fileInfo?.creatorInfo?.employeeNo || '';
                this.owner = fileInfo.creator + (employeeNo ? ` (${employeeNo})` : '');
                if (this.productType !== 'WIKI_FILE') {
                  return;
                }
              }
            } else {
              this.showSensitiveBlocked = false;
              this.showSensitiveContentTips = false;
            }

            this.message = "";
            this.auth = auth;
            this.showExportOptions(contentType);
            document.title = intl.$t(`{fileName} - 同程管家#!!!#src/pages/H5/Cloud/views/File.vue_1`, { fileName: fileName });
            this.handleInitAvatar();
            // 获取文档节点信息并添加查看记录
            if (type !== "1") {
              try {
                const nodeInfo = await queryFileNodeInfo(this.fileId);
                if (nodeInfo.code === 200 && nodeInfo.data) {
                  this.setDocInfo(nodeInfo.data || {});
                  this.creatorInfo = nodeInfo.data.creator;
                  this.ownerInfo = nodeInfo.data.owner;
                  this.typeInfo = {
                    hasChild: nodeInfo.data.hasChild,
                    type: nodeInfo.data?.type,
                    productType: nodeInfo.data.productType
                  };
                }
              } catch (error) {}
            }
            if (type !== "0") {
              this.loading = false;
              this.component = DirectoryView;
              break;
            }
            if (utils.isEditor(contentType)) {
              this.loading = false;
              this.component = EditorView;
              setTimeout(() => {
                this.$refs.componentRef.updateDocInfo({ fileName });
              });
              break;
            }
            if (utils.isVideo(fileName)) {
              this.isVideo = true;
              this.loading = false;
              this.component = VideoView;
              break;
            }
            if (utils.isAudio(fileName)) {
              this.loading = false;
              this.component = AudioView;
              break;
            }
            if (utils.isImage(fileName)) {
              this.loading = false;
              this.component = ImageView;
              break;
            }
            if (this.isTencentDoc) {
              if (utils.isTDWps(fileName) && !utils.isExceedMaxLimit(fileInfo.size)) {
                this.loading = false;
                this.isWps = true;
                this.component = TencentOfficeView;
                break;
              }
            } else
            {
              if (utils.isWps(fileName)) {
                this.loading = false;
                this.isWps = true;
                this.component = OfficeView;
                break;
              }
            }


            this.loading = false;
            this.component = DownloadView;
            break;
          case 116:
            this.loading = false;
            this.message = intl.$t("该文件已损坏或已被删除#!!!#src/pages/H5/Cloud/views/File.vue_1");
            this.component = MessageView;
            this.hideHeader = true;
            break;
          case 163:
            this.loading = false;
            this.message = intl.$t("该链接已经过期#!!!#src/pages/H5/Cloud/views/File.vue_1");
            this.component = MessageView;
            this.hideHeader = true;
            break;
          case 164:
            this.loading = false;
            this.message = "";
            this.component = PasswordView;
            this.hideHeader = true;
            break;
          case 165:
            this.loading = false;
            cookies.set(key, "");
            this.message = intl.$t("请输入正确的密码#!!!#src/pages/H5/Cloud/views/File.vue_1");
            this.component = PasswordView;
            this.hideHeader = true;
            break;
          default:
            this.loading = false;
            this.message = message;
            this.component = MessageView;
            this.hideHeader = true;
            break;
        }
      } catch (error) {
        console.log('----------------------redirect error:', error);
      } finally {
        this.cloudLoading = false;
      }
    },

    pre() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
        this.getCurrentFile();
      }
    },
    next() {
      if (this.currentIndex < this.fileList?.length - 1) {
        this.currentIndex += 1;
        this.getCurrentFile();
      }
    },
    async fetchFilePath(fileId) {
      try {
        this.routeItems = [];
        const res = await queryFilePath(fileId, !this.isWiki);
        const { code, data, message } = res;
        if (code == 200) {
          this.routeItems = data.map((item) => ({
            ...item,
            placeholder: false
          }));
          console.log(
            "fetchFilePath",
            data.map((item) => ({
              ...item,
              placeholder: false
            }))
          );
        }
      } catch {}
    },
    // 获取路由上文件列表
    getQueryFileList() {
      const query = this.$route.query;
      const { fileList = "", fid = "", rid = "" } = query;
      this.fileId = fid;
      if (fid && fid.length > 0) {
        //兼容fid为空的情况，兼容老版本逻辑
        this.fetchFilePath(fid);
      }
      this.rootId = rid || this.rootId || fid;
      if (fileList) {
        // 兼容老版本
        this.fileList = fileList?.split(",");
        this.currentIndex =
        this.fileList.findIndex((item) => item === this.fileId) || 0;
        this.getCurrentFile();
      } else {
        this.fileList = [];
        this.currentIndex = 0;
        this.redirect();
      }

      // 兼容本地cookies逻辑
      if (!fid) {
        const fids = cookies.get("fids");
        if (fids) {
          const index = cookies.get("fidIndex") || 0;
          const fileIds = fids?.split(",");
          const fid = fileIds[index];
          this.fileId = fid;
          this.rootId = this.rootId || fid;
          this.fileList = fileIds;
          this.currentIndex = index;
          this.getCurrentFile();
        }
      }
    },

    // 当文件或下标变更时触发
    getCurrentFile() {
      if (this.fileList?.length > 0 && this.fileList[this.currentIndex]) {
        const fileId = this.fileList[this.currentIndex];
        this.fileId = fileId;
        this.redirect();
      }
    },

    // 登陆逻辑
    handleLogin() {
      const isFromFile = window.location.href.includes(WEB_PATH.file);
      const path = isFromFile ?
      window.location.href?.split(WEB_PATH.file)[1] :
      window.location.href?.split(WEB_PATH.cloud)[1];
      goLogin(window.location.href, AGENT_ID.file);
      // authorize({
      //   redirectUrl: window.location.href,
      //   agentId: AGENT_ID.file,
      //   BASE_URL: process.env.VUE_APP_BASE_URL
      // })
    },

    // 关闭分享弹窗
    handleCloseShareView(val) {
      this.showAuthManage = this.showAuthShare = val;
    },

    // 跳转到申请更多权限
    changeToApplyAuthView(title) {
      this.message = title ?? intl.$t("申请更多权限#!!!#src/pages/H5/Cloud/views/File.vue_2");
      this.applyAuthDialog = true;
    },
    async handleFIleSocketMessage(message) {
      const { eventType, eventBody } = message;
      console.error('eventType', eventType);
      switch (eventType) {
        case "FILE_COMPRESS":
          if (this.isFolder) {
            const { fileId, downloadId } = eventBody;
            const url = `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD_URL}/public/download/zip/${downloadId}`;
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("target", "_self");
            document.body.appendChild(link);
            link.click();
            setTimeout(() => document.body.removeChild(link), 200);
            buried.reportPoint("下载", "more_download");
          }
          break;
        case "FILE_ONLINE_USERS_CHANGED":
          this.editUser = eventBody.users;
          // 暂时去掉，企微文档会一直发这个消息
          //   this.handleTemplateInfo();
          break;
        case "AUTH_CHANGED":
          {
            const { auth = "", needPassword = false } = eventBody;
            this.showAuthManage = this.showAuthShare = this.applyAuthDialog = false;
            if (!auth) {
              this.$message.success(intl.$t(`你在此文档的权限变更为无权限查看#!!!#src/pages/H5/Cloud/views/File.vue_1`));
            } else {
              if (!needPassword) {
                const authName = AUTH_DETAIL_LIST.find(
                  (item) => item.id === auth
                );
                this.$message.success(intl.$t(`你在此文档的权限变更为{slot0}#!!!#src/pages/H5/Cloud/views/File.vue_1`, { slot0: authName?.name }));
              }
            }
            this.loading = false;
            if (!!needPassword) {
              this.$message.warning(intl.$t("该文件已重置密码，请输入密码后查看#!!!#src/pages/H5/Cloud/views/File.vue_1"));
            }
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
          break;
        case "FILE_RENAMED":
          const { fileName } = eventBody;
          // this.redirect();
          this.metadata.fileName = fileName;
          if (this.docInfo?.contentType === "DOCUMENT") {
            this.$refs.componentRef.updateDocInfo({ fileName });
          }

          // if (this.component = DirectoryView) {
          //   this.$refs.componentRef.load();
          // }
          // this.loading = false;
          break;
        case "FILE_DELETED":
          this.loading = false;
          this.message = intl.$t("该文件已损坏或已被删除#!!!#src/pages/H5/Cloud/views/File.vue_2");
          this.component = MessageView;
          this.hideHeader = true;
          break;
        case "FILE_TRANSFERRED":
          // 转移文件所有权成功
          this.$message.success(intl.$t("转移所有权成功#!!!#src/pages/H5/Cloud/views/File.vue_1"));
          break;
        case "EXPORT_PDF":
          try {
            if (this.containDownloadId(eventBody.fileId) || this.containDownloadId(eventBody.downloadId)) {
              await downloadPDFAPI(
                eventBody.fileId,
                eventBody.downloadId,
                eventBody.fileName,
                {
                  userId: this.userId,
                  spaceId: this.spaceId,
                  token: this.token,
                  deviceId: eventBody.deviceId
                },
                this.handleLogOut,
                this.$message
              );
              this.removeDownloadIds(eventBody.downloadId);
            }
          } catch (err) {
            this.$message.clear();
            console.error(err);
            this.$message.error(intl.$t("文件生成失败#!!!#src/pages/H5/Cloud/views/File.vue_3"));
          }
          break;
        case TencentDocSocketEvents.OFFICE_TASK_COMPLETED:
          const { fileId } = eventBody;
          if (this.containDownloadId(fileId)) downloadTencentDoc(eventBody, { message: this.$message });
          break;
        case "OFFICE_PREVIEW_MODE_CHANGED":
          window.location.reload();
          break;
        case "WIKI_SPACE_SETTINGS_CHANGED":
          window.location.reload();
          break;
        case "URL_AUTH_CHANGED":
          {
            const { auth, scope, fileId } = eventBody;
            this.updateLinkShareInfo(auth, scope, fileId);
          }
          break;
        case "FILE_RISK_CHANGED":
          {
            const { riskType } = eventBody;
            this.handleRiskTypeChanged(riskType);
          }
          break;
        case "PERMISSION_SETTINGS_CHANGED":
          {
            const { fileId } = eventBody;
            const { auth } = this;
            if (fileId === this.fileId && auth !== 'ALL') {
              this.$message.success(intl.$t(`你在此文档的复制权限发生变更#!!!#src/pages/H5/Cloud/views/File.vue_1`));

              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          }
          break;
        default:
          break;
      }
    },
    handleRiskTypeChanged(riskType) {
      // 判定是否是为包含敏感信息的高风险页面（非所有者查看提示缺省页，所有者查看提示顶部横幅（SensitiveContentTips））
      const creatorId = this.precheckDocInfo?.creatorInfo?.userId;
      if (riskType === 'HIGH' || riskType === 'MEDIUM' || riskType === 'LOW') {
        // 复检失败
        if (creatorId === this.userId) {
          this.showSensitiveContentTips = true;
          this.showSensitiveBlocked = false;
          this.tocaWikiSensitiveTips.setSensitiveTipsStatus(2);
        } else {
          // 展示缺省页
          this.showSensitiveBlocked = true;
          this.hideHeader = true; // 隐藏原来的头部
          const employeeNo = this.precheckDocInfo?.creatorInfo?.employeeNo || '';
          this.owner = this.precheckDocInfo.creator + (employeeNo ? ` (${employeeNo})` : '');
          return false;
        }
      } else {
        this.showSensitiveContentTips = false;
        if (this.showSensitiveBlocked === true) {
          this.showSensitiveBlocked = false;
          this.redirect();
        }
      }
    },
    handleSocketSuccess() {
      const { fid } = this.$route.query;
      try {
        const fileOpenInfo = JSON.stringify({
          eventType: "FILE_OPENED",
          eventBody: {
            fileId: fid
          }
        });
        this.fileSocket.ws.send(fileOpenInfo);
      } catch (err) {}
    },
    handleInitCookies() {
      const { fid } = this.$route.query;
      if (!(fid && fid.length > 0)) {
        //兼容fid为空的情况
        return;
      }
      const spaceId = getSpaceId(this.showtype) || "";
      const userId = getUserId(this.showtype) || "";
      const token = getToken(this.showtype) || "";
      const deviceId = (getDeviceId(this.showtype) || "").replace(/\//g, "");
      //   if (!deviceId) {
      //     return;
      //   }

      // 初始化上传组件
      const options = {
        domain: process.env.VUE_APP_UPLOAD, // 接口域名
        debug:
        process.env.VUE_APP_STATIC_NODE_ENV !== "production" ? true : false, // 是否调试模式, 将打印大量信息
        maxWorkers: 1, // 最大同时允许几个任务
        headers: {
          deviceType: "1",
          spaceId,
          userId,
          token,
          deviceId
        }
      };
      const fileUploaderInit = new FileUploader(options);
      this.fileUploader = fileUploaderInit;
      // 上传事件监听
      fileUploaderInit.on("new-tasks", (tasks) => {
        this.newTasks(tasks);
        this.$refs.uploadDialog.showUploadDialog(true);
      });

      fileUploaderInit.on("remove-task", (tid) => {
        this.removeTasks(tid);
      });

      fileUploaderInit.on("task-status-change", (tid, status) => {
        this.changeTaskStatus({ tid, status });
      });

      fileUploaderInit.on("upload-speed", (e) => {
        this.changeUploadSpeed(e);
      });

      fileUploaderInit.on("upload-progress", (e) => {
        this.changeUploadProgress(e);
      });

      fileUploaderInit.on("complete", (task) => {
        // 文件上传完成
        if (this.isFolder) {
          setTimeout(() => {
            this.$refs.componentRef.refresh();
          }, 500);
        }
        this.$refs.uploadDialog.showUploadDialog(true);
      });

      let socketConfig = {
        onMessage: this.handleFIleSocketMessage,
        onSuccess: this.handleSocketSuccess,
        fid,
        reconnectCallback: this.reconnectCallback
      };
      let fileSocket = null;
      if (spaceId && userId && token) {
        this.fileSocket && this.fileSocket.ws.close();
        fileSocket = new Socket({
          params: { spaceId, userId, deviceId },
          ...socketConfig
        });
        fileSocket.init();
      } else {
        this.fileSocket && this.fileSocket.ws.close();
        fileSocket = new Socket(socketConfig);
        fileSocket.init();
      }
      this.fileSocket = fileSocket;

      this.spaceId = spaceId;
      this.userId = userId;
      this.token = token;
    },
    changeFavicon(contentType, fileName) {
      if (this.isWiki) {
        return;
      }
      let imgName = "";
      if (!fileName) {
        imgName = fileImgName(contentType);
      } else {
        if (contentType === "DOCUMENT") {
          imgName = "cloud-online-doc";
        } else {
          if (this.isFolder) {
            imgName = fileImgName("FOLDER");
          } else {
            const index = fileName.lastIndexOf(".");
            if (index === -1) {
              imgName = fileImgName(contentType);
            } else {
              const ext = fileName.substr(index + 1).toLowerCase();
              imgName = fileImgName(ext);
            }
          }
        }
      }
      const baseUrl = process.env.VUE_APP_STATIC;
      let faviconUrl = `${baseUrl}/dist/cloudIco/${imgName}.ico`;
      if (process.env.VUE_APP_STATIC_NODE_ENV === "development") {
        const devUrl = window.location.origin;
        faviconUrl = `${devUrl}/cloudIco/${imgName}.ico`;
      }
      let $favicon = document.querySelector('link[rel="icon"]');
      if ($favicon !== null) {
        $favicon.href = faviconUrl;
      } else {
        $favicon = document.createElement("link");
        $favicon.rel = "icon";
        $favicon.href = faviconUrl;
        document.head.appendChild($favicon);
      }
    },
    showExportOptions(contentType) {
      if (this.isTencentDoc) {
        //删除导出图片
        this.exportOptions = this.exportOptions.filter(
          (i) => i.type !== "image"
        );
      }
      switch (contentType) {
        case "WORD":
          const wordOption = {
            name: intl.$t("Word文档#!!!#src/pages/H5/Cloud/views/File.vue_1"),
            icon: "icon-file-word",
            type: "WORD"
          };
          if (
          this.exportOptions.findIndex(
            (i) =>
            i.name === wordOption.name &&
            i.icon === wordOption.icon &&
            i.type === wordOption.type
          ) === -1)
          {
            this.exportOptions.splice(0, 0, wordOption);
          }
          break;
        case "PPT":
          const pptOption = {
            name: intl.$t("PPT文稿#!!!#src/pages/H5/Cloud/views/File.vue_1"),
            icon: "icon-file-ppt",
            type: "PPT"
          };
          if (
          this.exportOptions.findIndex(
            (i) =>
            i.name === pptOption.name &&
            i.icon === pptOption.icon &&
            i.type === pptOption.type
          ) === -1)
          {
            this.exportOptions.splice(0, 0, pptOption);
          }
          break;
        case "EXCEL":
          this.exportOptions = this.exportOptions.filter(
            (i) => i.type !== "pdf"
          );
          const excelOption = {
            name: intl.$t("Excel表格#!!!#src/pages/H5/Cloud/views/File.vue_1"),
            icon: "icon-file-excel",
            type: "EXCEL"
          };
          if (
          this.exportOptions.findIndex(
            (i) =>
            i.name === excelOption.name &&
            i.icon === excelOption.icon &&
            i.type === excelOption.type
          ) === -1)
          {
            this.exportOptions.splice(0, 0, excelOption);
          }
          break;
      }
    },
    initSavior() {
      if (this.isPcMode && window.setBaseData) {
        setBaseData({
          platid: "10138",
          productid: "198",
          company: "3"
        });
      }
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
      if (this.fileSocket) {
        if (!this.onLine) {
          this.fileSocket.clearWs();
        } else {
          this.fileSocket.init();
        }
      } else {
        if (this.onLine) {
          this.handleInitCookies();
        }
      }
    },
    reconnectCallback() {
      // this.reconnectVisible = true;
      buried.reportWSErrorPoint(this.userId || cookies.get("userId"));
      this.reconnectConfirm();
    },
    reconnectConfirm() {
      if (this.fileSocket) {
        this.fileSocket.reconnectCount = 0;
        this.fileSocket.init();
      } else {
        this.handleInitCookies();
      }
      // this.reconnectVisible = false;
    },
    clickAuthManage() {
      this.showShareTip = false;
      this.showAuthShare = false;
      this.showAuthManage = !this.showAuthManage;
      if (this.showAuthManage) {
        buried.reportPoint("打开分享", "open_share");
      }
    },
    clickShare() {
      setSaviorConfigure({
        expandfield: {
          source: this.isMettingDoc === true ? "meeting" : "docs",
          fid: this.fileId
        }
      });
      updateSaviorData({
        eventtype: "click",
        category: "cloud_document",
        label: "share",
        eventid: "cloud_document_operation"
      });
      setSaviorConfigure({ expandfield: {} });
      if (this.isMettingDoc === true) {
        // 如果是会议纪要，直接复制链接
        this.$refs.fileShareScopeViewRef?.createCopyArea(this.metadata?.fileUrl);
        return;
      }
      this.showShareScopeTip = false;
      this.showAuthManage = false;
      this.showAuthShare = !this.showAuthShare;
      if (this.showAuthShare) {
        buried.reportPoint("打开分享", "open_share");
      }
    },
    pushToAuthManageView() {
      this.showAuthShare = false;
      this.showAuthManage = true;
    },
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        if (this.fileSocket?.ws) {
          if (this.fileSocket.changeTab) {
            this.fileSocket.changeTab = false;
          }
        } else {
          this.fileSocket = null;
          this.handleInitCookies();
        }
      } else {
        if (this.fileSocket?.ws) {
          this.fileSocket.changeTab = true;
        }
      }
    },
    expandDir() {
      this.isKBDirExpandShow = false;
      setTimeout(() => {
        window.parent.postMessage("expandKBDir", "*");
      }, 10);
    },
    handleMessage(message) {
      if (this.$route.query?.source === "wiki") {
        console.log("------wiki message:", message);
        if (message.data === "foldKBDir") {
          this.isKBDirExpandShow = true;
        } else if (message.data === "starFile") {
          this.metadata.star = true;
        } else if (message.data === "unstarFile") {
          this.metadata.star = false;
        } else if (message.data === "getMoreAuth") {
          this.applyAuthDialog = true;
        } else if (message.data.type === "handleSave") {
          let data = message.data.data;
          this.$refs.componentRef.
          handleSave().
          then(() => {
            setTimeout(() => {
              window.parent.postMessage(
                { type: "saveFileFinished", data: data },
                "*"
              );
            }, 1500);
          }).
          catch(() => {
            setTimeout(() => {
              window.parent.postMessage(
                { type: "saveFileFinished", data: data },
                "*"
              );
            }, 1500);
          });
        } else if (message.data === "updateBreadcrumb") {
          this.fetchFilePath(this.fileId);
        } else if (message.data === "openAISearch") {
          this.destroyAi();
        } else if (message.data === "closeAISearch") {
          if (this.showAiEntry) {
            this.loadWikiAiChat();
            this.loadWikiAiEntry();
          }
        }
      }
    },
    closeTransferDialog() {
      this.showTransferDialog = false;
    },
    floderAuthChange(auth) {
      this.auth = auth;
    },
    handleFullscreenChange() {
      if (!this.watermarkText) return;
      if (document.fullscreenElement) {
        watermark.set(
          this.watermarkText,
          ".kd-new-ui",
          "water-mark-cloud-full-screen",
          "calc(100vh - 54px)"
        );
      } else {
        document.querySelector(".water-mark-cloud-full-screen")?.remove();
      }
    },
    loadCheckReminder() {
      //   setTimeout(() => {
      if (this.checkMinder !== null) {
        return;
      }
      const cookie = {
        token: cookies.get("token"),
        spaceId: cookies.get("spaceId"),
        userId: cookies.get("userId"),
        deviceId: cookies.get("deviceId"),
        memberUniqueId: cookies.get("memberUniqueId") || this.currentUser.id,
        memberId: cookies.get("memberId") || this.currentUser.id
      };
      let env = process.env.VUE_APP_STATIC_NODE_ENV;
      let showAddAuth = false;
      if (this.isMettingDoc === true) {
        showAddAuth = true;
      } else {
        if (this.auth === 'ALL') {
          showAddAuth = true;
        }
      }
      const params = {
        locale: this.cloudI18n,
        env: env,
        isShowAddAuth: showAddAuth,
        userInfo: cookie,
        fileId: this.fileId,
        onGetDocMentionUserList: () => {
          if (this.contentType === "DOCUMENT") {
            return this.tocaEditor?.editor?.commands?.getAllMentionParagraphText();
          }
        },
        onGetDocCollaboratorList: () => {
          const collaboratorList = this.authInfos.filter((item) => {
            return item.toType === "PERSON" && item.memberIdentity === "COLLABORATOR";
          });
          return collaboratorList.map((item) => {
            return {
              anchorId: '',
              content: '',
              spaceId: item.toSpace,
              userId: item.to
            };
          });
        }
      };
      //   console.log('------ load check reminder params:', params);
      this.checkMinder = new TocaWikiCheckReminder(
        "#check_reminder_container",
        params
      );
      //   }, 1500);
    },
    mountHeadLinkShareRangeSet() {
      this.linkShareRangeSet = mountHeadLinkShareRangeSet(
        '#link_share_range_set',
        this.isWiki,
        this.locale,
        this.fileId,
        this.canUpdateUrlAuth,
        (auth, scope, expireDate, password, spaceInfo, shareAuthTip) => {
          // console.log('--------------------------onUpdateShareRange:', auth, scope, expireDate, password, spaceInfo,shareAuthTip);
          this.updateLinkShareRange(auth, scope, expireDate, password, spaceInfo, shareAuthTip);
        },
        (shareAuthTip) => {
          // console.log('--------------------------shareAuthTip:', shareAuthTip);
          this.setShareAuthTip(shareAuthTip);
        },
        this.onLinkRangeSetDropdownVisible
      );
    },
    UpdateLinkShareRangeSet(canUpdate) {
      this.canUpdateUrlAuth = canUpdate;
    },
    onLinkRangeSetDropdownVisible(domId, visible) {
      if (domId === '#link_share_range_set' && visible) {
        this.showAuthManage = false;
        this.showAuthShare = false;
      }
    },
    updateLinkShareInfo(auth, scope, fileId) {
      if (this.linkShareRangeSet) {
        this.linkShareRangeSet.updateShareRangeInfo(auth, scope, null, '', {
          spaceId: this.wikiSpaceInfo?.id,
          spaceName: this.wikiSpaceInfo?.spaceName
        }, '');
      }
      if (this.$refs.fileShareViewRef) {
        this.$refs.fileShareViewRef.updateShareInfo(auth, scope, fileId);
      }
      if (this.$refs.fileShareScopeViewRef) {
        this.$refs.fileShareScopeViewRef.updateShareInfo(auth, scope, fileId);
      }
    },
    updateLinkShareRange(auth, scope, expireDate, password, spaceInfo, shareAuthTip, watermarkText) {
      // 统一收口
      if (this.linkShareRangeSet) {
        this.linkShareRangeSet.updateShareRangeInfo(auth, scope, expireDate, password, spaceInfo, watermarkText);
      }
      // 修改分享按钮提示文案
      this.setShareAuthTip(shareAuthTip);
    }

  },
  created() {
    document.body.style.overscrollBehaviorX = "none";

    let env = process.env.VUE_APP_STATIC_NODE_ENV;
    if (env === "development") {
      cookies.set("deviceId", "9799470058464ec12c958d5f7ea67393");
      cookies.set("token", "8aa0b570e5354a1d847ba61350612b57");
      cookies.set("spaceId", "0583d");
      cookies.set("userId", "154263553403101184");
      cookies.set("memberId", "213672292987805696");
    }

    const fids = cookies.get("fids");
    if (!this.$route.query.fileList && !this.$route.query.fid && !fids) {
      this.message = intl.$t("该文件已损坏或已被删除#!!!#src/pages/H5/Cloud/views/File.vue_3");
      this.component = MessageView;
      this.hideHeader = true;
      return;
    }

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);

    this.socketHeart = setInterval(() => {
      try {
        const heartBeat = JSON.stringify({
          eventType: "HEART_BEAT"
        });
        this.fileSocket.ws.send(heartBeat);
      } catch {}
    }, 10000);
  },
  mounted() {
    this.updateTemplateType();
    if (this.$route.query?.source === "wikiHome") {
      // console.log("this.$route.query?.source === 'wiki'", window.parent, window.parent.childrenClearAllCookies);
      this.isWiki = true;
      this.isHome = true;
    }
    if (this.$route.query?.source === "wiki") {
      // console.log("this.$route.query?.source === 'wiki'", window.parent, window.parent.childrenClearAllCookies);
      this.isWiki = true;
    }
    if (this.$route.query?.source === "home") {
      this.isHome = true;
    }
    setRedirectCallback(() => {
      if (this.$route.query?.source === "wiki") {
        window.parent.childrenClearAllCookies();
      }

      this.handleLogOut(false);
    });
    setTimeout(() => this.handleInitAvatar());
    this.handleInitCookies();
    this.getQueryFileList();
    this.initSavior();

    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    //知识库目录展开折叠通信
    window.addEventListener("message", this.handleMessage);
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
  },
  watch: {
    metadata: {
      handler(value) {
        if (!!value) {
          if (value?.contentType == "DOCUMENT" || this.isFolder) {
            this.fileTitle = value?.fileName;
          } else {
            this.fileTitle = utils.getFileName(value?.fileName);
          }
          this.handleAi();
        }
      },
      immediate: true,
      deep: true
    },
    canUpdateUrlAuth: {
      handler(val) {
        if (this.linkShareRangeSet) {
          this.linkShareRangeSet.UpdateLinkShareRangeSet(val);
        }
        if (this.$refs.fileShareViewRef) {
          this.$refs.fileShareViewRef.UpdateLinkShareRangeSet(val);
        }
        if (this.$refs.fileShareScopeViewRef) {
          this.$refs.fileShareScopeViewRef.UpdateLinkShareRangeSet(val);
        }
      },
      immediate: true
    },
    isTemplate: {
      handler(val) {
        if (val === true) {
          this.handleTemplateInfo();
        }
      }
    },
    isShowCheckReminder: {
      handler(val) {
        if (val === true) {
          this.$nextTick(() => {
            this.loadCheckReminder();
          });
        }
      },
      immediate: true
    },
    isShowShareRangeSet: {
      handler(val) {
        if (val === true) {
          this.$nextTick(() => {
            this.mountHeadLinkShareRangeSet();
          });
        }
      },
      immediate: true
    },
    drawerVisible(val) {
      if (val) {
        this.handleViewVisible("flex");
      } else {
        this.handleViewVisible("flex");
      }
    },
    recentVisible(val) {
      this.setRecentViewShow(val);
    },
    showHistory(val) {
      if (val === true) {
        document.getElementById("toca-wiki-ai-entry").style.display = "none";
        document.getElementById("toca-wiki-ai-chat").style.display = "none";
      } else {
        document.getElementById("toca-wiki-ai-entry").style.display = "block";
        document.getElementById("toca-wiki-ai-chat").style.display = "block";
      }
    },
    cloudLoading(val) {
      if (val === false) {
        var element = document.getElementById("cloud-html-loading");
        if (element) {
          element.parentNode.removeChild(element);
        }
      }
    },
    isShowSensitiveContentTips(val) {
      if (val === true) {
        setTimeout(() => {
          const cookie = {
            token: cookies.get("token"),
            spaceId: cookies.get("spaceId"),
            userId: cookies.get("userId"),
            deviceId: cookies.get("deviceId"),
            memberUniqueId: cookies.get("memberUniqueId") || this.currentUser.id,
            memberId: cookies.get("memberId") || this.currentUser.id
          };
          this.$nextTick(() => {
            this.tocaWikiSensitiveTips = new TocaWikiSensitiveTips('#sensitive_content_tip', {
              locale: this.cloudI18n,
              env: process.env.VUE_APP_STATIC_NODE_ENV,
              fileId: this.fileId,
              userInfo: cookie,
              onClickComplete: async (type) => {
                if (type === 'modify') {
                  if (this.precheckDocInfo?.contentType === "DOCUMENT") {
                    this.$refs.componentRef.save(async () => {
                      const res = await recognizeRisk(this.fileId);
                      if (res.code === 200) {
                        this.$message.success(intl.$t("提交成功#!!!#src/pages/H5/Cloud/views/File.vue_1"));
                        this.tocaWikiSensitiveTips.setSensitiveTipsStatus(1);
                      } else {
                        this.$message.error(intl.$t("提交失败，请重新提交#!!!#src/pages/H5/Cloud/views/File.vue_1"));
                      }
                    });
                  } else {
                    const result = await this.$refs.componentRef.handleSave();
                    const res = await recognizeRisk(this.fileId);
                    if (res.code === 200) {
                      this.$message.success(intl.$t("提交成功#!!!#src/pages/H5/Cloud/views/File.vue_2"));
                      this.tocaWikiSensitiveTips.setSensitiveTipsStatus(1);
                    } else {
                      this.$message.error(intl.$t("提交失败，请重新提交#!!!#src/pages/H5/Cloud/views/File.vue_2"));
                    }
                  }
                } else if (type === 'misJudge') {
                  feedbackRisk(this.fileId);
                }
              }
            });
            this.tocaWikiSensitiveTips?.setSensitiveTipsStatus(0);
          });
        }, 500);
      }
    },
    isShowSensitiveBlocked(val) {
      if (val === true) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.tocaWikiSensitiveBlocked = new TocaWikiSensitiveBlocked('#sensitive_blocked_id', {
              locale: this.cloudI18n,
              env: process.env.VUE_APP_STATIC_NODE_ENV,
              userName: this.owner || ''
            });
          });
        }, 500);
      }
    },
    wikiSpaceInfo(val) {
      if (val) {
        const creatorId = this.precheckDocInfo?.creatorInfo?.userId;
        const isHIGH = this.riskType === 'HIGH' || this.riskType === 'MEDIUM' || this.riskType === 'LOW';
        if (isHIGH === true) {
          if (creatorId === this.userId || val && val.memberIdentity === 'ADMIN') {
            this.showSensitiveContentTips = true;
            this.showSensitiveBlocked = false;
          } else {
            // 展示缺省页
            this.showSensitiveBlocked = true;
            this.showSensitiveContentTips = false;
            this.hideHeader = true; // 隐藏原来的头部
            const employeeNo = this.precheckDocInfo?.creatorInfo?.employeeNo || '';
            this.owner = this.precheckDocInfo?.creator + (employeeNo ? ` (${employeeNo})` : '');
          }
        } else {
          this.showSensitiveBlocked = false;
          this.showSensitiveContentTips = false;
        }
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    window.removeEventListener("message", this.handleMessage);
    document.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    );
  },
  destroyed() {
    clearInterval(this.socketHeart);
    this.fileSocket.clearWs();
    // try {
    //   const fileCloseInfo = JSON.stringify({
    //     eventType: 'FILE_CLOSED',
    //     eventBody: {
    //       fileId: this.fileId
    //     }
    //   });
    //   this.fileSocket.ws.send(fileCloseInfo);
    //   clearInterval(this.socketHeart);
    // } catch { }
  }
};
</script>

<style lang="scss" scoped>
.toca_wiki_template_container {
  z-index: 999;
  position: fixed;
  width: 100%;
  height: 100%;
}

.file-container-other {
  height: 100vh !important;
}

.file-container-doc-mobile {
  height: 100% !important;
}

.file-container {
  width: 100%;
  height: 100%;
  position: relative;

  .left-arrow,
  .right-arrow {
    display: none;
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);

    img {
      width: 64px;
      height: 64px;
    }
  }

  .left-arrow {
    left: 0px;
  }

  .right-arrow {
    right: 0px;
  }

  .touch-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    position: relative;

    .water-mark-show-mobile {
      height: calc(100% - 43px) !important;
    }

    #water-mark-show {
      position: relative;
      z-index: 99;
      overflow: hidden;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .mobile-header {
      width: 100%;
      height: 42px;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-flow: row;
      padding: 0 14px;
      box-sizing: border-box;
      box-shadow: inset 0 -1px 0 0 #dee0e3;

      .mobile-header-left {
        img {
          margin-top: 4px;
          width: 94px;
          height: 24px;
        }
      }

      .mobile-header-right {
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: center;

        .mobile-user-avatar {
          width: 24px;
          height: 24px;
          border-radius: 5px;
        }

        .mobile-login-button {
          width: 56px;
          height: 29px;
          text-align: center;
          line-height: 29px;
          background: #5c70ff;
          border-radius: 6px;
          font-weight: 500;
          font-size: 12px;
          color: #ffffff;
        }

        .line {
          width: 1px;
          height: 20px;
          background-color: #dee0e3;
          margin-left: 14px;
          margin-right: 14px;
        }

        .save {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;

          &:active {
            background-color: #f4f6f9 !important;
          }

          svg {
            width: 20px;
            height: 20px;
          }
        }
      }
    }

    .wps-custom-mobile-header {
      z-index: 100;
      position: relative;
    }

    .wps-shadow {
      box-shadow: inset 0 -1px 0 0 #e2e6ed;
    }

    .header {
      height: 54px;
      width: 100%;
      flex-shrink: 0;
      background: #ffffff;
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      align-items: center;

      .header-left-center {
        justify-content: center !important;
      }

      .recent-file-btn {
            width: 26px;
            height: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            margin-left: 12px;
            cursor: pointer;
            border-radius: 4px;

            .icon-file-recent {
                width: 16px;
                height: 16px;
            }
        }

        .recent-file-btn:hover {
            background: #E8E9E9;
        }

      .recent-file-right-line {
        background-color: #E8E9E9;
        width: 1px;
        height: calc(100% - 20px);
        margin: 10px 0px;
      }

      .header-left {
        flex: 1;
        height: 100%;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        padding: 8px 28px 8px 12px;
        box-sizing: border-box;
        overflow: hidden;

        .header-left-top-nobread {
          height: 54px !important;
        }

        .header-left-top {
          height: 17px;
          display: flex;
          flex-flow: row;
          align-items: center;
          letter-spacing: 0;
          overflow: hidden;
          text-align: left;
          text-overflow: ellipsis;
          white-space: nowrap;
          min-width: 10px;

          .input-box {
            margin-right: 32px;
            display: inline-flex;
            align-items: center;
            box-sizing: border-box;
            position: relative;
            height: 40px;
            min-width: 10px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            letter-spacing: 0;
            padding-right: 10px;

            .input-box__label {
              display: inline-block;
              font-size: inherit;
              line-height: normal;
              visibility: hidden;
              font-family: inherit;
              letter-spacing: inherit;
              padding: 0 10px;
            }

            .input-box__input {
              background: #f4f6f9;
              box-sizing: border-box;
              position: absolute;
              display: inline;
              font-size: inherit;
              font-family: inherit;
              letter-spacing: inherit;
              line-height: normal;
              border-radius: inherit;
              height: 24px;
              width: 100%;
              outline: 0;
              border: 0;
              margin: 0;
              padding: 0 10px;
            }
          }

          .title {
            padding: 0 6px 0 0px;
            min-width: 10px;
            font-family: "PingFang SC", "Avenir Next", Avenir, "Helvetica Neue",
              Helvetica, Arial, sans-serif;
            font-weight: 600;
            font-size: 14px;
            color: #3d4757;
            letter-spacing: 0;
            overflow: hidden;
            text-align: left;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .templateMark_en {
            width: 52px !important;
            svg {
              width: 52px !important;
            }
          }

          .templateMark {
            width: 28px;
            height: 16px;
            margin-right: 6px;
            display: flex;
            align-items: center;
            svg {
              width: 28px;
              height: 16px;
            }
          }

          .file-status {
            flex-shrink: 0;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #3d4757;
            letter-spacing: 0;

            .done-icon {
              width: 13px;
              height: 13px;
            }
          }
        }

        .header-crumb {
          line-height: 21px;
          height: 17px;
          margin-top: 1px;
          overflow: hidden;
          display: flex;
          flex-flow: row;
          align-items: center;

          .bread-crumb-icon {
            margin-right: 4px;
            display: flex;
            height: 16px;
            width: 16px;
            align-items: center;
            justify-content: center;
            .icon {
              width: 16px;
              height: 16px;
            }
          }
        }
      }

      .header-left-noAuth {
        justify-content: center !important;
      }

      .header-middle {
        flex: 1;
        // width: 225px;
        height: 20px;
        display: flex;
        flex-flow: row;
        align-items: center;

        span {
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 12px;
          color: #3d4757;
          letter-spacing: 0;
          min-width: 44px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          border-radius: 2px;
          margin-right: 8px;

          &:hover {
            color: #5c70ff;
          }
        }

        .excel-bar {
          color: #5c70ff;
          border-bottom: 2px solid #5c70ff;
        }
      }

      .header-right {
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: flex-end;
        margin-right: 16px;
        min-width: 420px;

        .sendEmail {
          margin-left: 12px;
          width: 72px;
          height: 26px;
          line-height: 26px;
          background: #ffffff;
          border: 1px solid #5c70ff;
          border-radius: 4px;
          font-weight: 400;
          font-size: 14px;
          color: #5c70ff;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-color: #5c70ff;
            color: #ffffff;
          }
        }

        .login-button {
          width: 60px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          background: #5c70ff;
          border-radius: 6px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          margin-right: 16px;
        }

        .header-icon {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 5px;
          width: 16px;
          height: 16px;
        }

        .header-icon:hover {
          background: #f4f6f9;
          border-radius: 4px;
        }

        .more-file {
          margin-left: 17px;
        }

        .edit-user-no-more-user {
            margin-right: 0px !important;
        }

        .edit-user {
          display: flex;
          flex-flow: row;
          margin-right: 0px;
          align-items: center;

            .more_user_count {
                height: 26px;
                min-width: 26px;
                margin-left: 4px;
                margin-right: 0px;
                border-radius: 4px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                &:hover {
                    background-color: #F4F6F9;
                }

                .number {
                    margin: 3px 4px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #323233;
                }
            }
        }

        .line {
          width: 1px;
          height: 16px;
          background: #e2e6ed;
          border-radius: 1px;
          margin: 0 16px;
        }

        .authManageBtn,
        .shareBtn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 26px;
          height: 26px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          font-family: PingFangSC-Regular;
          color: #ffffff;
          margin-left: 12px;

          .share-btn-auth-manage {
            width: 16px;
            height: 16px;
          }

          &:hover {
            background-color: #f4f6f9;
          }
        }

        .edit-btn-disabled {
          cursor: not-allowed !important;
          border: 1px solid #e8e9ee !important;
          color: #222329 !important;

          .edit-btn-icon {
            fill: #646a73 !important;
            stroke: #646a73 !important;
          }
        }

        .edit-btn {
          width: 92px;
          height: 26px;
          background: #ffffff;
          border: 1px solid #e8e9ee;
          color: #222329;
          border-radius: 4px;
          margin-left: 12px;
          display: flex;
          flex-flow: row;
          align-items: center;
          justify-content: center;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          letter-spacing: 0;
          cursor: pointer;

          .edit-btn-icon {
            margin-right: 4px;
            fill: #646a73;
            stroke: #646a73;
          }
        }

        .edit-btn:hover {
          color: #5c70ff;
          border-color: #5c70ff;

          .edit-btn-icon {
            fill: #5c70ff;
            stroke: #5c70ff;
          }
        }

        .btn-margin {
          margin-right: 8px;
        }

        .download-btn {
          margin-left: 12px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 90px;
          height: 26px;
          background: #ffffff;
          border: 1px solid #e8e9ee;
          border-radius: 6px;
          cursor: pointer;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 13px;
          color: #222329;
          letter-spacing: 0;

          .download-btn-icon {
            width: 12px;
            height: 12px;
            margin-right: 2px;
          }

          &:hover {
            background: #f4f6f9;
          }
        }
      }
    }

    .wps-custom-header {
      z-index: 100;

      .expandBtnContainer {
        margin-left: 12px;
        margin-right: 0px;
        width: 26px !important;
        height: 26px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background-color: #eaebec;
        }

        .kb_dir_expand_icon {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}

.create-file-popper {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-end;

  .upload-popper {
    display: none;
    position: absolute;
    width: 170px;
    height: auto;
    left: -160px;
    top: 0;
    background: #ffffff;
    border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    border-radius: 8px;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding: 4px;

    span {
      justify-content: flex-start;

      &:hover {
        background: #f4f6f9;
      }
    }

    &:hover {
      display: flex;
    }
  }

  .upload-tip {
    width: 200px;
  }

  .upload-tip:hover {
    .upload-popper {
      display: flex;
    }
  }

  span {
    font-weight: 400;
    font-size: 14px;
    color: #222329;
    letter-spacing: 0;
    width: 100%;
    height: 40px;
    border-radius: 8px;
    line-height: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    position: relative;

    .create-tip {
      width: 184px;
      height: 100%;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-radius: 8px;

      &:hover {
        background: #f4f6f9;
      }
    }

    .file-icon {
      cursor: pointer;
      width: 24px;
      height: 24px;
      margin: 0 8px;
    }

    .upload-file {
      width: 16px;
      height: 16px;
      margin: 0 8px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 8px;
      margin: auto 0;
    }
  }
}

.office-pop {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-end;

  .export-popper {
    display: none;
    position: absolute;
    width: 146px;
    height: auto;
    left: -101px;
    top: -8px;
    background: #ffffff;
    border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    border-radius: 8px;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding: 4px;

    span {
      justify-content: flex-start;

      &:hover {
        background: #f4f6f9;
      }
    }

    &:hover {
      display: flex;
    }
  }

  .export-tip {
    width: 200px;
  }

  .export-tip:hover {
    .export-popper {
      display: flex;
    }
  }

  span {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-weight: 400;
    font-size: 14px;
    color: #222329;
    letter-spacing: 0;
    width: 184px;
    height: 32px;
    margin: 4px 0;
    background: transparent;
    border-radius: 8px;
    line-height: 20px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;

    .more-tip {
      width: 184px;
      height: 100%;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-radius: 8px;

      &:hover {
        background: #f4f6f9;
      }
    }

    .file-icon {
      width: 16px;
      height: 16px;
      margin: 0 8px;
    }

    .arrow-file {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 8px;
      margin: auto 0;
    }
  }
}

.file-container:hover {
  .left-arrow,
  .right-arrow {
    display: block;
  }

  @media (max-width: 750px) {
    .left-arrow,
    .right-arrow {
      display: none;
    }
  }
}

.loading {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  img {
    width: 100px;
  }

  span {
    font-size: 17px;
    color: rgba(0, 0, 0, 0.5);
  }
}

::v-deep .moo-dialog {
  border-radius: 16px;
}

::v-deep .moo-dialog__header {
  display: none !important;
}

::v-deep .moo-dialog__body {
  padding: 0;
}
</style>

<style lang="scss">
.common-popper {
  width: 184px !important;
  padding: 4px 4px !important;
  height: 112px;
  background: #ffffff;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  box-sizing: border-box;
  height: auto !important;
  margin-top: 8px !important;

  .popper__arrow {
    display: none !important;
  }
}

.common-popper.create-popper {
  width: 184px !important;
  margin-top: 8px !important;
}

.customPoperClass {
  top: 35px !important;
  border-radius: 4px m !important;
  color: #767c85;
  font-size: 14px !important;
  font-weight: 400;
  padding: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border: none !important;
  height: 22px;
  line-height: 24px !important;
  margin-top: 5px !important;
  text-align: center !important;
}

.customPoperClass_wiki {
  top: 35px !important;
  border-radius: 4px m !important;
  color: #767c85;
  font-size: 14px !important;
  font-weight: 400;
  padding: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border: none !important;
  height: 22px;
  line-height: 24px !important;
  margin-top: 5px !important;
  text-align: center !important;
}

.file-popper {
  width: 180px !important;
  height: auto !important;
}

.more-popper {
  width: 146px !important;
  height: auto !important;
}

.edit-popper {
  width: 180px !important;
  max-height: 277px !important;
  background: #ffffff;
  border: 1px solid #e6e8ec;
  box-shadow: 0 8px 12px 0 #1213171a;
  border-radius: 8px;
  padding: 0 !important;
  overflow-y: auto;

  .edit-pop {
    width: 180px;
    height: auto;
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 8px;
    box-sizing: border-box;

    .user-item {
      display: flex;
      flex-flow: row;
      width: 164px;
      height: 40px;
      border-radius: 8px;
      align-items: center;
      padding: 4px 12px;
      box-sizing: border-box;

      &:hover {
        background: #f1f2f5;
      }

      .user-hidden-avatar {
        width: 32px;
        height: 32px;
        border-radius: 8px;
        margin-right: 12px;
      }

      span {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #121317;
        letter-spacing: 0;
        line-height: 20px;
      }
    }
  }
}

.sign-out-dialog {
  height: 172px;
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  z-index: 9999;

  .mobile-content {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;

    .title {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 17px;
      color: #121317;
      text-align: center;
      line-height: 24px;
    }

    .content {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #393d47;
      text-align: center;
      line-height: 20px;
    }

    .footer {
      display: flex;
      width: 100%;
      display: flex;
      flex-flow: row;
      justify-content: flex-end;
      margin-top: 32px;

      .custom-button {
        cursor: pointer;
        width: 126px;
        height: 44px;
        border: none;
        background: #f6f7f9;
        border-radius: 10px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #222329;
        text-align: center;
        line-height: 44px;
      }

      .primary-button {
        margin-left: 12px;
        background: #ff4747;
        color: #ffffff;
      }

      .reconnect-button {
        margin-left: 12px;
        background: #5c70ff;
        color: #ffffff;
      }
    }
  }

  .title {
    font-family: "PingFang SC", sans-serif;
    font-weight: 600;
    font-size: 16px;
    color: #000000d9;
    line-height: 24px;
    margin-bottom: 16px;

    .dialog-icon {
      width: 16px;
      height: 16px;
    }
  }

  .content {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #121317;
    padding-left: 24px;
  }

  .footer {
    display: flex;
    width: 100%;
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    margin-top: 32px;

    .custom-button {
      cursor: pointer;
      width: 76px;
      height: 32px;
      background: #ffffff;
      border: 1px solid #e8e9ee;
      border-radius: 4px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #222329;
      text-align: center;
      line-height: 32px;
    }

    .link-button {
      &:hover {
        background: #f4f6f9;
      }
    }

    .primary-button {
      margin-left: 12px;
      background: #ff4747;
      color: #ffffff;

      &:hover {
        background: #ff5f5f;
      }
    }

    .reconnect-button {
      margin-left: 12px;
      background: #5c70ff;
      color: #ffffff;

      &:hover {
        background: #6d7dff;
      }
    }
  }
}

.file-drawer {
  border-radius: 16px 16px 0 0;
  width: 100%;
  height: 267px !important;
  background: #f5f7fc !important;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;

  .drawer-title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #222329;
    letter-spacing: 0;
    position: relative;
    margin-bottom: 16px;

    .drawer-icon {
      position: absolute;
      right: 0;
      width: 28px;
      height: 28px;
    }
  }

  .drawer-sign-out {
    width: 343px;
    height: 54px;
    background: #ffffff;
    border-radius: 10px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #ff4747;
    letter-spacing: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 13px;
    cursor: pointer;
  }

  .drawer-info {
    border-radius: 10px;
    width: 343px;
    background: #ffffff;
    height: 122px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;

    .info-item {
      padding: 0 16px;
      box-sizing: border-box;
      width: 343px;
      flex: 1;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #323233;
      line-height: 20px;
      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: space-between;

      span {
        flex-shrink: 0;
        margin-right: 10px;
      }

      .info-avatar {
        width: 36px;
        height: 36px;
      }

      .info-department {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #646a73;
        letter-spacing: 0;
        text-align: right;
      }
    }
  }
}

.recent-file-popper {
  width: 300px !important;
  // min-height: 374px !important;
  // max-height: 567px !important;
  // height: 350px !important;
  background: transparent !important;
  // border: 1px solid #E6E8EC !important;
  // box-shadow: 0 8px 12px 0 #1213171a !important;
  // border-radius: 8px !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin-top: -24px !important;
}

.share-tooltip-class {
  top: 35px !important;
  border-radius: 8px !important;
  color: #767c85 !important;
  font-size: 14px !important;
  font-weight: 400;
  padding: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border: none !important;
  height: 22px;
  line-height: 24px !important;
  margin-top: 13px !important;
  text-align: center !important;
}

.saveTemplateClass {
  width: 529px;
  height: 172px;

  .moo-dialog__header {
    display: block !important;
    padding: 24px 24px 10px 24px;

    .moo-dialog__title {
      font-weight: 600;
      font-size: 16px;
      color: #000000d9;
      line-height: 24px;
    }

    .moo-dialog__headerbtn {
      display: none;
    }
  }

  .moo-dialog__body {
    padding: 6px 24px 12px 24px;

    font-weight: 400;
    font-size: 14px;
    color: #121317;
    line-height: 20px;
  }

  .moo-dialog__footer {
    .dialog-footer {
      .moo-button {
        line-height: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 76px;
        height: 32px;
      }

      .moo-button--default {
        background-color: #ffffff;
        color: #222329;
        &:hover {
          color: #222329;
          background-color: #e8e9ee;
        }
      }

      .moo-button--primary {
        background-color: #5c70ff;
        &:hover {
          background-color: #6d7dff;
        }
      }
    }
  }
}
.v-modal {
  opacity: 0.4 !important;
}
</style>
